import _e, { useCallback as V, createContext as de, useContext as ue, useReducer as me, useRef as rt, useState as G, useEffect as X, useMemo as at, forwardRef as fe } from "react";
import Te from "camelize-ts";
import Se from "snakecase-keys";
var Zt, Ft = { exports: {} }, St = {}, xt, zt, kt = {};
function Pe() {
  return xt || (xt = 1, t = kt, process.env.NODE_ENV !== "production" && (function() {
    var e = _e, s = 60103, o = 60106;
    t.Fragment = 60107;
    var l = 60108, T = 60114, m = 60109, v = 60110, C = 60112, N = 60113, n = 60120, E = 60115, f = 60116, A = 60121, a = 60122, d = 60117, u = 60129, S = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var y = Symbol.for;
      s = y("react.element"), o = y("react.portal"), t.Fragment = y("react.fragment"), l = y("react.strict_mode"), T = y("react.profiler"), m = y("react.provider"), v = y("react.context"), C = y("react.forward_ref"), N = y("react.suspense"), n = y("react.suspense_list"), E = y("react.memo"), f = y("react.lazy"), A = y("react.block"), a = y("react.server.block"), d = y("react.fundamental"), y("react.scope"), y("react.opaque.id"), u = y("react.debug_trace_mode"), y("react.offscreen"), S = y("react.legacy_hidden");
    }
    var b = typeof Symbol == "function" && Symbol.iterator, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(R) {
      for (var H = arguments.length, M = new Array(H > 1 ? H - 1 : 0), k = 1; k < H; k++) M[k - 1] = arguments[k];
      (function(Z, j, K) {
        var z = i.ReactDebugCurrentFrame, J = "";
        if (c) {
          var st = p(c.type), B = c._owner;
          J += (function(F, et, ct) {
            var nt = "";
            if (et) {
              var Dt = et.fileName, Tt = Dt.replace(_, "");
              if (/^index\./.test(Tt)) {
                var Et = Dt.match(_);
                if (Et) {
                  var $t = Et[1];
                  $t && (Tt = $t.replace(_, "") + "/" + Tt);
                }
              }
              nt = " (at " + Tt + ":" + et.lineNumber + ")";
            } else ct && (nt = " (created by " + ct + ")");
            return `
    in ` + (F || "Unknown") + nt;
          })(st, c._source, B && p(B.type));
        }
        (J += z.getStackAddendum()) !== "" && (j += "%s", K = K.concat([J]));
        var w = K.map(function(F) {
          return "" + F;
        });
        w.unshift("Warning: " + j), Function.prototype.apply.call(console[Z], console, w);
      })("error", R, M);
    }
    var _ = /^(.*)[\\\/]/, h = 1;
    function p(R) {
      if (R == null) return null;
      if (typeof R.tag == "number" && r("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof R == "function") return R.displayName || R.name || null;
      if (typeof R == "string") return R;
      switch (R) {
        case t.Fragment:
          return "Fragment";
        case o:
          return "Portal";
        case T:
          return "Profiler";
        case l:
          return "StrictMode";
        case N:
          return "Suspense";
        case n:
          return "SuspenseList";
      }
      if (typeof R == "object") switch (R.$$typeof) {
        case v:
          return "Context.Consumer";
        case m:
          return "Context.Provider";
        case C:
          return k = R, Z = R.render, j = "ForwardRef", K = Z.displayName || Z.name || "", k.displayName || (K !== "" ? j + "(" + K + ")" : j);
        case E:
          return p(R.type);
        case A:
          return p(R.render);
        case f:
          var H = (M = R)._status === h ? M._result : null;
          if (H) return p(H);
      }
      var M, k, Z, j, K;
      return null;
    }
    var P = {};
    i.ReactDebugCurrentFrame;
    var c = null;
    function I(R) {
      c = R;
    }
    var U, g, $ = i.ReactCurrentOwner, Y = Object.prototype.hasOwnProperty, x = { key: !0, ref: !0, __self: !0, __source: !0 };
    function ut(R, H, M, k, Z) {
      var j, K = {}, z = null, J = null;
      for (j in M !== void 0 && (z = "" + M), (function(w) {
        if (Y.call(w, "key")) {
          var F = Object.getOwnPropertyDescriptor(w, "key").get;
          if (F && F.isReactWarning) return !1;
        }
        return w.key !== void 0;
      })(H) && (z = "" + H.key), (function(w) {
        if (Y.call(w, "ref")) {
          var F = Object.getOwnPropertyDescriptor(w, "ref").get;
          if (F && F.isReactWarning) return !1;
        }
        return w.ref !== void 0;
      })(H) && (J = H.ref, (function(w) {
        typeof w.ref == "string" && $.current;
      })(H)), H) Y.call(H, j) && !x.hasOwnProperty(j) && (K[j] = H[j]);
      if (R && R.defaultProps) {
        var st = R.defaultProps;
        for (j in st) K[j] === void 0 && (K[j] = st[j]);
      }
      if (z || J) {
        var B = typeof R == "function" ? R.displayName || R.name || "Unknown" : R;
        z && (function(w, F) {
          var et = function() {
            U || (U = !0, r("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", F));
          };
          et.isReactWarning = !0, Object.defineProperty(w, "key", { get: et, configurable: !0 });
        })(K, B), J && (function(w, F) {
          var et = function() {
            g || (g = !0, r("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", F));
          };
          et.isReactWarning = !0, Object.defineProperty(w, "ref", { get: et, configurable: !0 });
        })(K, B);
      }
      return (function(w, F, et, ct, nt, Dt, Tt) {
        var Et = { $$typeof: s, type: w, key: F, ref: et, props: Tt, _owner: Dt, _store: {} };
        return Object.defineProperty(Et._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: !1 }), Object.defineProperty(Et, "_self", { configurable: !1, enumerable: !1, writable: !1, value: ct }), Object.defineProperty(Et, "_source", { configurable: !1, enumerable: !1, writable: !1, value: nt }), Object.freeze && (Object.freeze(Et.props), Object.freeze(Et)), Et;
      })(R, z, J, Z, k, $.current, K);
    }
    var q, W = i.ReactCurrentOwner;
    function it(R) {
      c = R;
    }
    function ht(R) {
      return typeof R == "object" && R !== null && R.$$typeof === s;
    }
    function ft() {
      if (W.current) {
        var R = p(W.current.type);
        if (R) return `

Check the render method of \`` + R + "`.";
      }
      return "";
    }
    i.ReactDebugCurrentFrame, q = !1;
    var It = {};
    function Ot(R, H) {
      if (R._store && !R._store.validated && R.key == null) {
        R._store.validated = !0;
        var M = (function(Z) {
          var j = ft();
          if (!j) {
            var K = typeof Z == "string" ? Z : Z.displayName || Z.name;
            K && (j = `

Check the top-level render call using <` + K + ">.");
          }
          return j;
        })(H);
        if (!It[M]) {
          It[M] = !0;
          var k = "";
          R && R._owner && R._owner !== W.current && (k = " It was passed a child from " + p(R._owner.type) + "."), it(R), r('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', M, k), it(null);
        }
      }
    }
    function yt(R, H) {
      if (typeof R == "object") {
        if (Array.isArray(R)) for (var M = 0; M < R.length; M++) {
          var k = R[M];
          ht(k) && Ot(k, H);
        }
        else if (ht(R)) R._store && (R._store.validated = !0);
        else if (R) {
          var Z = (function(z) {
            if (z === null || typeof z != "object") return null;
            var J = b && z[b] || z["@@iterator"];
            return typeof J == "function" ? J : null;
          })(R);
          if (typeof Z == "function" && Z !== R.entries) for (var j, K = Z.call(R); !(j = K.next()).done; ) ht(j.value) && Ot(j.value, H);
        }
      }
    }
    function Ct(R) {
      var H, M = R.type;
      if (M != null && typeof M != "string") {
        if (typeof M == "function") H = M.propTypes;
        else {
          if (typeof M != "object" || M.$$typeof !== C && M.$$typeof !== E) return;
          H = M.propTypes;
        }
        if (H) {
          var k = p(M);
          (function(Z, j, K, z, J) {
            var st = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var B in Z) if (st(Z, B)) {
              var w = void 0;
              try {
                if (typeof Z[B] != "function") {
                  var F = Error((z || "React class") + ": " + K + " type `" + B + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Z[B] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw F.name = "Invariant Violation", F;
                }
                w = Z[B](j, B, z, K, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (et) {
                w = et;
              }
              !w || w instanceof Error || (I(J), r("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", z || "React class", K, B, typeof w), I(null)), w instanceof Error && !(w.message in P) && (P[w.message] = !0, I(J), r("Failed %s type: %s", K, w.message), I(null));
            }
          })(H, R.props, "prop", k, R);
        } else M.PropTypes === void 0 || q || (q = !0, r("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", p(M) || "Unknown"));
        typeof M.getDefaultProps != "function" || M.getDefaultProps.isReactClassApproved || r("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Rt(R, H, M, k, Z, j) {
      var K = (function(F) {
        return typeof F == "string" || typeof F == "function" || F === t.Fragment || F === T || F === u || F === l || F === N || F === n || F === S || typeof F == "object" && F !== null && (F.$$typeof === f || F.$$typeof === E || F.$$typeof === m || F.$$typeof === v || F.$$typeof === C || F.$$typeof === d || F.$$typeof === A || F[0] === a);
      })(R);
      if (!K) {
        var z, J = "";
        (R === void 0 || typeof R == "object" && R !== null && Object.keys(R).length === 0) && (J += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), J += ft(), R === null ? z = "null" : Array.isArray(R) ? z = "array" : R !== void 0 && R.$$typeof === s ? (z = "<" + (p(R.type) || "Unknown") + " />", J = " Did you accidentally export a JSX literal instead of a component?") : z = typeof R, r("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", z, J);
      }
      var st = ut(R, H, M, Z, j);
      if (st == null) return st;
      if (K) {
        var B = H.children;
        if (B !== void 0) if (k) if (Array.isArray(B)) {
          for (var w = 0; w < B.length; w++) yt(B[w], R);
          Object.freeze && Object.freeze(B);
        } else r("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
        else yt(B, R);
      }
      return R === t.Fragment ? (function(F) {
        for (var et = Object.keys(F.props), ct = 0; ct < et.length; ct++) {
          var nt = et[ct];
          if (nt !== "children" && nt !== "key") {
            it(F), r("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", nt), it(null);
            break;
          }
        }
        F.ref !== null && (it(F), r("Invalid attribute `ref` supplied to `React.Fragment`."), it(null));
      })(st) : Ct(st), st;
    }
    var gt = function(R, H, M) {
      return Rt(R, H, M, !1);
    }, bt = function(R, H, M) {
      return Rt(R, H, M, !0);
    };
    t.jsx = gt, t.jsxs = bt;
  })()), kt;
  var t;
}
var wt = (zt || (zt = 1, process.env.NODE_ENV === "production" ? Ft.exports = (function() {
  if (Zt) return St;
  Zt = 1;
  var t = _e, e = 60103;
  if (St.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var s = Symbol.for;
    e = s("react.element"), St.Fragment = s("react.fragment");
  }
  var o = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = Object.prototype.hasOwnProperty, T = { key: !0, ref: !0, __self: !0, __source: !0 };
  function m(v, C, N) {
    var n, E = {}, f = null, A = null;
    for (n in N !== void 0 && (f = "" + N), C.key !== void 0 && (f = "" + C.key), C.ref !== void 0 && (A = C.ref), C) l.call(C, n) && !T.hasOwnProperty(n) && (E[n] = C[n]);
    if (v && v.defaultProps) for (n in C = v.defaultProps) E[n] === void 0 && (E[n] = C[n]);
    return { $$typeof: e, type: v, key: f, ref: A, props: E, _owner: o.current };
  }
  return St.jsx = m, St.jsxs = m, St;
})() : Ft.exports = Pe()), Ft.exports);
const oo = () => ({ ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://platform.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" }), ve = (t) => {
  switch (t) {
    case "text/csv":
      return "csv";
    case "image/jpeg":
      return "jpeg";
    case "application/json":
      return "json";
    case "text/markdown":
      return "md";
    case "application/vnd.oasis.opendocument.presentation":
      return "odp";
    case "application/vnd.oasis.opendocument.spreadsheet":
      return "ods";
    case "image/png":
      return "png";
    case "application/pdf":
      return "pdg";
    case "application/vnd.ms-powerpoint":
      return "ppt";
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "pptx";
    case "application/vnd.rar":
      return "rar";
    case "application/rtf":
      return "rtf";
    case "application/x-tar":
      return "tar";
    case "text/plain":
      return "txt";
    case "application/vnd.ms-excel":
      return "xls";
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "xlsx";
    case "application/zip":
    case "application/x-zip-compressed":
      return "zip";
    default:
      return void console.warn("unsupported mime type", t);
  }
}, Gt = (t, e) => {
  let s, o = t;
  try {
    let l = e.split(".");
    for (l.length === 0 && (l = [e]); l.length > 0; ) {
      if (s = l.shift(), !s) return;
      if (Array.isArray(o[s])) {
        o = [];
        const T = l.splice(-1).join(".");
        for (let m = 0, v = t[s].length; m < v; m++) o.push(Gt(t[s][m], T));
      } else o = o[s];
    }
    return o;
  } catch (l) {
    return void console.error("unexpected error occurred while trying to find value from pointer", t, e, l);
  }
}, po = (t, e, s) => {
  let o, l = -1;
  for (let T = 0, m = t?.length; T < m; T += 1) if (o = Gt(t[T], e), Array.isArray(o)) {
    if (o.indexOf(s) !== -1) {
      l = T;
      break;
    }
  } else if (o === s) {
    l = T;
    break;
  }
  return l;
}, ye = (t, e, s = !1) => {
  const o = [...t].sort((l, T) => {
    let m = Gt(l, e.toString()), v = Gt(T, e.toString());
    return typeof m == "string" && (m = m.toLocaleLowerCase()), typeof v == "string" && (v = v.toLocaleLowerCase()), m === v ? 0 : m < v ? -1 : 1;
  });
  return s ? o.reverse() : o;
};
var Bt, Wt, Jt, pt = {}, tt = {};
function mt() {
  if (Bt) return tt;
  Bt = 1;
  var t = tt.ValidationError = function(a, d, u, S, y, b) {
    if (Array.isArray(S) ? (this.path = S, this.property = S.reduce(function(r, _) {
      return r + v(_);
    }, "instance")) : S !== void 0 && (this.property = S), a && (this.message = a), u) {
      var i = u.$id || u.id;
      this.schema = i || u;
    }
    d !== void 0 && (this.instance = d), this.name = y, this.argument = b, this.stack = this.toString();
  };
  t.prototype.toString = function() {
    return this.property + " " + this.message;
  };
  var e = tt.ValidatorResult = function(a, d, u, S) {
    this.instance = a, this.schema = d, this.options = u, this.path = S.path, this.propertyPath = S.propertyPath, this.errors = [], this.throwError = u && u.throwError, this.throwFirst = u && u.throwFirst, this.throwAll = u && u.throwAll, this.disableFormat = u && u.disableFormat === !0;
  };
  function s(a, d) {
    return d + ": " + a.toString() + `
`;
  }
  function o(a) {
    typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, o), this.instance = a.instance, this.schema = a.schema, this.options = a.options, this.errors = a.errors;
  }
  e.prototype.addError = function(a) {
    var d;
    if (typeof a == "string") d = new t(a, this.instance, this.schema, this.path);
    else {
      if (!a) throw new Error("Missing error detail");
      if (!a.message) throw new Error("Missing error message");
      if (!a.name) throw new Error("Missing validator type");
      d = new t(a.message, this.instance, this.schema, this.path, a.name, a.argument);
    }
    if (this.errors.push(d), this.throwFirst) throw new o(this);
    if (this.throwError) throw d;
    return d;
  }, e.prototype.importErrors = function(a) {
    typeof a == "string" || a && a.validatorType ? this.addError(a) : a && a.errors && (this.errors = this.errors.concat(a.errors));
  }, e.prototype.toString = function(a) {
    return this.errors.map(s).join("");
  }, Object.defineProperty(e.prototype, "valid", { get: function() {
    return !this.errors.length;
  } }), tt.ValidatorResultError = o, o.prototype = new Error(), o.prototype.constructor = o, o.prototype.name = "Validation Error";
  var l = tt.SchemaError = function a(d, u) {
    this.message = d, this.schema = u, Error.call(this, d), typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, a);
  };
  l.prototype = Object.create(Error.prototype, { constructor: { value: l, enumerable: !1 }, name: { value: "SchemaError", enumerable: !1 } });
  var T = tt.SchemaContext = function(a, d, u, S, y) {
    this.schema = a, this.options = d, Array.isArray(u) ? (this.path = u, this.propertyPath = u.reduce(function(b, i) {
      return b + v(i);
    }, "instance")) : this.propertyPath = u, this.base = S, this.schemas = y;
  };
  T.prototype.resolve = function(a) {
    return A(this.base, a);
  }, T.prototype.makeChild = function(a, d) {
    var u = d === void 0 ? this.path : this.path.concat([d]), S = a.$id || a.id;
    let y = A(this.base, S || "");
    var b = new T(a, this.options, u, y, Object.create(this.schemas));
    return S && !b.schemas[y] && (b.schemas[y] = a), b;
  };
  var m = tt.FORMAT_REGEXPS = { "date-time": /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])[tT ](2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])(\.\d+)?([zZ]|[+-]([0-5][0-9]):(60|[0-5][0-9]))$/, date: /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])$/, time: /^(2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])$/, duration: /P(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S)|\d+(D|M(\d+D)?|Y(\d+M(\d+D)?)?)(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S))?|\d+W)/i, email: /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/, "idn-email": /^("(?:[!#-\[\]-\u{10FFFF}]|\\[\t -\u{10FFFF}])*"|[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}])*)@([!#-'*+\-/-9=?A-Z\^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}])*|\[[!-Z\^-\u{10FFFF}]*\])$/u, "ip-address": /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, ipv6: /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/, uri: /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/, "uri-reference": /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/, iri: /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/, "iri-reference": /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~-\u{10FFFF}]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~-\u{10FFFF}]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~-\u{10FFFF}])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~-\u{10FFFF}]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/u, uuid: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i, "uri-template": /(%[0-9a-f]{2}|[!#$&(-;=?@\[\]_a-z~]|\{[!#&+,./;=?@|]?(%[0-9a-f]{2}|[0-9_a-z])(\.?(%[0-9a-f]{2}|[0-9_a-z]))*(:[1-9]\d{0,3}|\*)?(,(%[0-9a-f]{2}|[0-9_a-z])(\.?(%[0-9a-f]{2}|[0-9_a-z]))*(:[1-9]\d{0,3}|\*)?)*\})*/iu, "json-pointer": /^(\/([\x00-\x2e0-@\[-}\x7f]|~[01])*)*$/iu, "relative-json-pointer": /^\d+(#|(\/([\x00-\x2e0-@\[-}\x7f]|~[01])*)*)$/iu, hostname: /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/, "host-name": /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/, "utc-millisec": function(a) {
    return typeof a == "string" && parseFloat(a) === parseInt(a, 10) && !isNaN(a);
  }, regex: function(a) {
    var d = !0;
    try {
      new RegExp(a);
    } catch {
      d = !1;
    }
    return d;
  }, style: /[\r\n\t ]*[^\r\n\t ][^:]*:[\r\n\t ]*[^\r\n\t ;]*[\r\n\t ]*;?/, color: /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/, phone: /^\+(?:[0-9] ?){6,14}[0-9]$/, alpha: /^[a-zA-Z]+$/, alphanumeric: /^[a-zA-Z0-9]+$/ };
  m.regexp = m.regex, m.pattern = m.regex, m.ipv4 = m["ip-address"], tt.isFormat = function(a, d, u) {
    if (typeof a == "string" && m[d] !== void 0) {
      if (m[d] instanceof RegExp) return m[d].test(a);
      if (typeof m[d] == "function") return m[d](a);
    } else if (u && u.customFormats && typeof u.customFormats[d] == "function") return u.customFormats[d](a);
    return !0;
  };
  var v = tt.makeSuffix = function(a) {
    return (a = a.toString()).match(/[.\s\[\]]/) || a.match(/^[\d]/) ? a.match(/^\d+$/) ? "[" + a + "]" : "[" + JSON.stringify(a) + "]" : "." + a;
  };
  function C(a, d, u, S) {
    typeof u == "object" ? d[S] = E(a[S], u) : a.indexOf(u) === -1 && d.push(u);
  }
  function N(a, d, u) {
    d[u] = a[u];
  }
  function n(a, d, u, S) {
    typeof d[S] == "object" && d[S] && a[S] ? u[S] = E(a[S], d[S]) : u[S] = d[S];
  }
  function E(a, d) {
    var u = Array.isArray(d), S = u && [] || {};
    return u ? (a = a || [], S = S.concat(a), d.forEach(C.bind(null, a, S))) : (a && typeof a == "object" && Object.keys(a).forEach(N.bind(null, a, S)), Object.keys(d).forEach(n.bind(null, a, d, S))), S;
  }
  function f(a) {
    return "/" + encodeURIComponent(a).replace(/~/g, "%7E");
  }
  tt.deepCompareStrict = function a(d, u) {
    if (typeof d != typeof u) return !1;
    if (Array.isArray(d)) return !!Array.isArray(u) && d.length === u.length && d.every(function(b, i) {
      return a(d[i], u[i]);
    });
    if (typeof d == "object") {
      if (!d || !u) return d === u;
      var S = Object.keys(d), y = Object.keys(u);
      return S.length === y.length && S.every(function(b) {
        return a(d[b], u[b]);
      });
    }
    return d === u;
  }, tt.deepMerge = E, tt.objectGetPath = function(a, d) {
    for (var u, S = d.split("/").slice(1); typeof (u = S.shift()) == "string"; ) {
      var y = decodeURIComponent(u.replace(/~0/, "~").replace(/~1/g, "/"));
      if (!(y in a)) return;
      a = a[y];
    }
    return a;
  }, tt.encodePath = function(a) {
    return a.map(f).join("");
  }, tt.getDecimalPlaces = function(a) {
    var d = 0;
    if (isNaN(a)) return d;
    typeof a != "number" && (a = Number(a));
    var u = a.toString().split("e");
    if (u.length === 2) {
      if (u[1][0] !== "-") return d;
      d = Number(u[1].slice(1));
    }
    var S = u[0].split(".");
    return S.length === 2 && (d += S[1].length), d;
  }, tt.isSchema = function(a) {
    return typeof a == "object" && a || typeof a == "boolean";
  };
  var A = tt.resolveUrl = function(a, d) {
    const u = new URL(d, new URL(a, "resolve://"));
    if (u.protocol === "resolve:") {
      const { pathname: S, search: y, hash: b } = u;
      return S + y + b;
    }
    return u.toString();
  };
  return tt;
}
var Qt, Xt, te, ee, Ht = {};
function Yt() {
  if (Qt) return Ht;
  Qt = 1;
  var t = mt();
  function e(s, o) {
    this.id = s, this.ref = o;
  }
  return Ht.SchemaScanResult = e, Ht.scan = function(s, o) {
    function l(N, n) {
      if (!n || typeof n != "object") return;
      if (n.$ref) {
        let a = t.resolveUrl(N, n.$ref);
        return void (C[a] = C[a] ? C[a] + 1 : 0);
      }
      var E = n.$id || n.id;
      let f = t.resolveUrl(N, E);
      var A = E ? f : N;
      if (A) {
        if (A.indexOf("#") < 0 && (A += "#"), v[A]) {
          if (!t.deepCompareStrict(v[A], n)) throw new Error("Schema <" + A + "> already exists with different definition");
          return v[A];
        }
        v[A] = n, A[A.length - 1] == "#" && (v[A.substring(0, A.length - 1)] = n);
      }
      T(A + "/items", Array.isArray(n.items) ? n.items : [n.items]), T(A + "/extends", Array.isArray(n.extends) ? n.extends : [n.extends]), l(A + "/additionalItems", n.additionalItems), m(A + "/properties", n.properties), l(A + "/additionalProperties", n.additionalProperties), m(A + "/definitions", n.definitions), m(A + "/patternProperties", n.patternProperties), m(A + "/dependencies", n.dependencies), T(A + "/disallow", n.disallow), T(A + "/allOf", n.allOf), T(A + "/anyOf", n.anyOf), T(A + "/oneOf", n.oneOf), l(A + "/not", n.not);
    }
    function T(N, n) {
      if (Array.isArray(n)) for (var E = 0; E < n.length; E++) l(N + "/" + E, n[E]);
    }
    function m(N, n) {
      if (n && typeof n == "object") for (var E in n) l(N + "/" + E, n[E]);
    }
    var v = {}, C = {};
    return l(s, o), new e(v, C);
  }, Ht;
}
function Re() {
  if (te) return Xt;
  te = 1;
  var t = (function() {
    if (Jt) return Wt;
    Jt = 1;
    var n = mt(), E = n.ValidatorResult, f = n.SchemaError, A = { ignoreProperties: { id: !0, default: !0, description: !0, title: !0, additionalItems: !0, then: !0, else: !0, $schema: !0, $ref: !0, extends: !0 } }, a = A.validators = {};
    function d(i, r, _, h, p) {
      var P = r.throwError, c = r.throwAll;
      r.throwError = !1, r.throwAll = !1;
      var I = this.validateSchema(i, p, r, _);
      return r.throwError = P, r.throwAll = c, !I.valid && h instanceof Function && h(I), I.valid;
    }
    function u(i, r) {
      if (Object.hasOwnProperty.call(i, r)) return i[r];
      if (r in i) {
        for (; i = Object.getPrototypeOf(i); ) if (Object.propertyIsEnumerable.call(i, r)) return i[r];
      }
    }
    function S(i, r, _, h, p, P) {
      if (this.types.object(i) && (!r.properties || r.properties[p] === void 0)) if (r.additionalProperties === !1) P.addError({ name: "additionalProperties", argument: p, message: "is not allowed to have the additional property " + JSON.stringify(p) });
      else {
        var c = r.additionalProperties || {};
        typeof _.preValidateProperty == "function" && _.preValidateProperty(i, p, c, _, h);
        var I = this.validateSchema(i[p], c, _, h.makeChild(c, p));
        I.instance !== P.instance[p] && (P.instance[p] = I.instance), P.importErrors(I);
      }
    }
    a.type = function(i, r, _, h) {
      if (i === void 0) return null;
      var p = new E(i, r, _, h), P = Array.isArray(r.type) ? r.type : [r.type];
      if (!P.some(this.testType.bind(this, i, r, _, h))) {
        var c = P.map(function(I) {
          if (I) {
            var U = I.$id || I.id;
            return U ? "<" + U + ">" : I + "";
          }
        });
        p.addError({ name: "type", argument: c, message: "is not of a type(s) " + c });
      }
      return p;
    }, a.anyOf = function(i, r, _, h) {
      if (i === void 0) return null;
      var p = new E(i, r, _, h), P = new E(i, r, _, h);
      if (!Array.isArray(r.anyOf)) throw new f("anyOf must be an array");
      if (!r.anyOf.some(d.bind(this, i, _, h, function(I) {
        P.importErrors(I);
      }))) {
        var c = r.anyOf.map(function(I, U) {
          var g = I.$id || I.id;
          return g ? "<" + g + ">" : I.title && JSON.stringify(I.title) || I.$ref && "<" + I.$ref + ">" || "[subschema " + U + "]";
        });
        _.nestedErrors && p.importErrors(P), p.addError({ name: "anyOf", argument: c, message: "is not any of " + c.join(",") });
      }
      return p;
    }, a.allOf = function(i, r, _, h) {
      if (i === void 0) return null;
      if (!Array.isArray(r.allOf)) throw new f("allOf must be an array");
      var p = new E(i, r, _, h), P = this;
      return r.allOf.forEach(function(c, I) {
        var U = P.validateSchema(i, c, _, h);
        if (!U.valid) {
          var g = c.$id || c.id || c.title && JSON.stringify(c.title) || c.$ref && "<" + c.$ref + ">" || "[subschema " + I + "]";
          p.addError({ name: "allOf", argument: { id: g, length: U.errors.length, valid: U }, message: "does not match allOf schema " + g + " with " + U.errors.length + " error[s]:" }), p.importErrors(U);
        }
      }), p;
    }, a.oneOf = function(i, r, _, h) {
      if (i === void 0) return null;
      if (!Array.isArray(r.oneOf)) throw new f("oneOf must be an array");
      var p = new E(i, r, _, h), P = new E(i, r, _, h), c = r.oneOf.filter(d.bind(this, i, _, h, function(U) {
        P.importErrors(U);
      })).length, I = r.oneOf.map(function(U, g) {
        return U.$id || U.id || U.title && JSON.stringify(U.title) || U.$ref && "<" + U.$ref + ">" || "[subschema " + g + "]";
      });
      return c !== 1 && (_.nestedErrors && p.importErrors(P), p.addError({ name: "oneOf", argument: I, message: "is not exactly one from " + I.join(",") })), p;
    }, a.if = function(i, r, _, h) {
      if (i === void 0) return null;
      if (!n.isSchema(r.if)) throw new Error('Expected "if" keyword to be a schema');
      var p, P = d.call(this, i, _, h, null, r.if), c = new E(i, r, _, h);
      if (P) {
        if (r.then === void 0) return;
        if (!n.isSchema(r.then)) throw new Error('Expected "then" keyword to be a schema');
        p = this.validateSchema(i, r.then, _, h.makeChild(r.then)), c.importErrors(p);
      } else {
        if (r.else === void 0) return;
        if (!n.isSchema(r.else)) throw new Error('Expected "else" keyword to be a schema');
        p = this.validateSchema(i, r.else, _, h.makeChild(r.else)), c.importErrors(p);
      }
      return c;
    }, a.propertyNames = function(i, r, _, h) {
      if (this.types.object(i)) {
        var p = new E(i, r, _, h), P = r.propertyNames !== void 0 ? r.propertyNames : {};
        if (!n.isSchema(P)) throw new f('Expected "propertyNames" to be a schema (object or boolean)');
        for (var c in i) if (u(i, c) !== void 0) {
          var I = this.validateSchema(c, P, _, h.makeChild(P));
          p.importErrors(I);
        }
        return p;
      }
    }, a.properties = function(i, r, _, h) {
      if (this.types.object(i)) {
        var p = new E(i, r, _, h), P = r.properties || {};
        for (var c in P) {
          var I = P[c];
          if (I !== void 0) {
            if (I === null) throw new f('Unexpected null, expected schema in "properties"');
            typeof _.preValidateProperty == "function" && _.preValidateProperty(i, c, I, _, h);
            var U = u(i, c), g = this.validateSchema(U, I, _, h.makeChild(I, c));
            g.instance !== p.instance[c] && (p.instance[c] = g.instance), p.importErrors(g);
          }
        }
        return p;
      }
    }, a.patternProperties = function(i, r, _, h) {
      if (this.types.object(i)) {
        var p = new E(i, r, _, h), P = r.patternProperties || {};
        for (var c in i) {
          var I = !0;
          for (var U in P) {
            var g = P[U];
            if (g !== void 0) {
              if (g === null) throw new f('Unexpected null, expected schema in "patternProperties"');
              try {
                var $ = new RegExp(U, "u");
              } catch {
                $ = new RegExp(U);
              }
              if ($.test(c)) {
                I = !1, typeof _.preValidateProperty == "function" && _.preValidateProperty(i, c, g, _, h);
                var Y = this.validateSchema(i[c], g, _, h.makeChild(g, c));
                Y.instance !== p.instance[c] && (p.instance[c] = Y.instance), p.importErrors(Y);
              }
            }
          }
          I && S.call(this, i, r, _, h, c, p);
        }
        return p;
      }
    }, a.additionalProperties = function(i, r, _, h) {
      if (this.types.object(i)) {
        if (r.patternProperties) return null;
        var p = new E(i, r, _, h);
        for (var P in i) S.call(this, i, r, _, h, P, p);
        return p;
      }
    }, a.minProperties = function(i, r, _, h) {
      if (this.types.object(i)) {
        var p = new E(i, r, _, h);
        return Object.keys(i).length >= r.minProperties || p.addError({ name: "minProperties", argument: r.minProperties, message: "does not meet minimum property length of " + r.minProperties }), p;
      }
    }, a.maxProperties = function(i, r, _, h) {
      if (this.types.object(i)) {
        var p = new E(i, r, _, h);
        return Object.keys(i).length <= r.maxProperties || p.addError({ name: "maxProperties", argument: r.maxProperties, message: "does not meet maximum property length of " + r.maxProperties }), p;
      }
    }, a.items = function(i, r, _, h) {
      var p = this;
      if (this.types.array(i) && r.items !== void 0) {
        var P = new E(i, r, _, h);
        return i.every(function(c, I) {
          if (Array.isArray(r.items)) var U = r.items[I] === void 0 ? r.additionalItems : r.items[I];
          else U = r.items;
          if (U === void 0) return !0;
          if (U === !1) return P.addError({ name: "items", message: "additionalItems not permitted" }), !1;
          var g = p.validateSchema(c, U, _, h.makeChild(U, I));
          return g.instance !== P.instance[I] && (P.instance[I] = g.instance), P.importErrors(g), !0;
        }), P;
      }
    }, a.contains = function(i, r, _, h) {
      var p = this;
      if (this.types.array(i) && r.contains !== void 0) {
        if (!n.isSchema(r.contains)) throw new Error('Expected "contains" keyword to be a schema');
        var P = new E(i, r, _, h);
        return i.some(function(c, I) {
          return p.validateSchema(c, r.contains, _, h.makeChild(r.contains, I)).errors.length === 0;
        }) === !1 && P.addError({ name: "contains", argument: r.contains, message: "must contain an item matching given schema" }), P;
      }
    }, a.minimum = function(i, r, _, h) {
      if (this.types.number(i)) {
        var p = new E(i, r, _, h);
        return r.exclusiveMinimum && r.exclusiveMinimum === !0 ? i > r.minimum || p.addError({ name: "minimum", argument: r.minimum, message: "must be greater than " + r.minimum }) : i >= r.minimum || p.addError({ name: "minimum", argument: r.minimum, message: "must be greater than or equal to " + r.minimum }), p;
      }
    }, a.maximum = function(i, r, _, h) {
      if (this.types.number(i)) {
        var p = new E(i, r, _, h);
        return r.exclusiveMaximum && r.exclusiveMaximum === !0 ? i < r.maximum || p.addError({ name: "maximum", argument: r.maximum, message: "must be less than " + r.maximum }) : i <= r.maximum || p.addError({ name: "maximum", argument: r.maximum, message: "must be less than or equal to " + r.maximum }), p;
      }
    }, a.exclusiveMinimum = function(i, r, _, h) {
      if (typeof r.exclusiveMinimum != "boolean" && this.types.number(i)) {
        var p = new E(i, r, _, h);
        return i > r.exclusiveMinimum || p.addError({ name: "exclusiveMinimum", argument: r.exclusiveMinimum, message: "must be strictly greater than " + r.exclusiveMinimum }), p;
      }
    }, a.exclusiveMaximum = function(i, r, _, h) {
      if (typeof r.exclusiveMaximum != "boolean" && this.types.number(i)) {
        var p = new E(i, r, _, h);
        return i < r.exclusiveMaximum || p.addError({ name: "exclusiveMaximum", argument: r.exclusiveMaximum, message: "must be strictly less than " + r.exclusiveMaximum }), p;
      }
    };
    var y = function(i, r, _, h, p, P) {
      if (this.types.number(i)) {
        var c = r[p];
        if (c == 0) throw new f(p + " cannot be zero");
        var I = new E(i, r, _, h), U = n.getDecimalPlaces(i), g = n.getDecimalPlaces(c), $ = Math.max(U, g), Y = Math.pow(10, $);
        return Math.round(i * Y) % Math.round(c * Y) !== 0 && I.addError({ name: p, argument: c, message: P + JSON.stringify(c) }), I;
      }
    };
    function b(i, r, _) {
      var h, p = _.length;
      for (h = r + 1; h < p; h++) if (n.deepCompareStrict(i, _[h])) return !1;
      return !0;
    }
    return a.multipleOf = function(i, r, _, h) {
      return y.call(this, i, r, _, h, "multipleOf", "is not a multiple of (divisible by) ");
    }, a.divisibleBy = function(i, r, _, h) {
      return y.call(this, i, r, _, h, "divisibleBy", "is not divisible by (multiple of) ");
    }, a.required = function(i, r, _, h) {
      var p = new E(i, r, _, h);
      return i === void 0 && r.required === !0 ? p.addError({ name: "required", message: "is required" }) : this.types.object(i) && Array.isArray(r.required) && r.required.forEach(function(P) {
        u(i, P) === void 0 && p.addError({ name: "required", argument: P, message: "requires property " + JSON.stringify(P) });
      }), p;
    }, a.pattern = function(i, r, _, h) {
      if (this.types.string(i)) {
        var p = new E(i, r, _, h), P = r.pattern;
        try {
          var c = new RegExp(P, "u");
        } catch {
          c = new RegExp(P);
        }
        return i.match(c) || p.addError({ name: "pattern", argument: r.pattern, message: "does not match pattern " + JSON.stringify(r.pattern.toString()) }), p;
      }
    }, a.format = function(i, r, _, h) {
      if (i !== void 0) {
        var p = new E(i, r, _, h);
        return p.disableFormat || n.isFormat(i, r.format, this) || p.addError({ name: "format", argument: r.format, message: "does not conform to the " + JSON.stringify(r.format) + " format" }), p;
      }
    }, a.minLength = function(i, r, _, h) {
      if (this.types.string(i)) {
        var p = new E(i, r, _, h), P = i.match(/[\uDC00-\uDFFF]/g);
        return i.length - (P ? P.length : 0) >= r.minLength || p.addError({ name: "minLength", argument: r.minLength, message: "does not meet minimum length of " + r.minLength }), p;
      }
    }, a.maxLength = function(i, r, _, h) {
      if (this.types.string(i)) {
        var p = new E(i, r, _, h), P = i.match(/[\uDC00-\uDFFF]/g);
        return i.length - (P ? P.length : 0) <= r.maxLength || p.addError({ name: "maxLength", argument: r.maxLength, message: "does not meet maximum length of " + r.maxLength }), p;
      }
    }, a.minItems = function(i, r, _, h) {
      if (this.types.array(i)) {
        var p = new E(i, r, _, h);
        return i.length >= r.minItems || p.addError({ name: "minItems", argument: r.minItems, message: "does not meet minimum length of " + r.minItems }), p;
      }
    }, a.maxItems = function(i, r, _, h) {
      if (this.types.array(i)) {
        var p = new E(i, r, _, h);
        return i.length <= r.maxItems || p.addError({ name: "maxItems", argument: r.maxItems, message: "does not meet maximum length of " + r.maxItems }), p;
      }
    }, a.uniqueItems = function(i, r, _, h) {
      if (r.uniqueItems === !0 && this.types.array(i)) {
        var p = new E(i, r, _, h);
        return i.every(b) || p.addError({ name: "uniqueItems", message: "contains duplicate item" }), p;
      }
    }, a.dependencies = function(i, r, _, h) {
      if (this.types.object(i)) {
        var p = new E(i, r, _, h);
        for (var P in r.dependencies) if (i[P] !== void 0) {
          var c = r.dependencies[P], I = h.makeChild(c, P);
          if (typeof c == "string" && (c = [c]), Array.isArray(c)) c.forEach(function(g) {
            i[g] === void 0 && p.addError({ name: "dependencies", argument: I.propertyPath, message: "property " + g + " not found, required by " + I.propertyPath });
          });
          else {
            var U = this.validateSchema(i, c, _, I);
            p.instance !== U.instance && (p.instance = U.instance), U && U.errors.length && (p.addError({ name: "dependencies", argument: I.propertyPath, message: "does not meet dependency required by " + I.propertyPath }), p.importErrors(U));
          }
        }
        return p;
      }
    }, a.enum = function(i, r, _, h) {
      if (i === void 0) return null;
      if (!Array.isArray(r.enum)) throw new f("enum expects an array", r);
      var p = new E(i, r, _, h);
      return r.enum.some(n.deepCompareStrict.bind(null, i)) || p.addError({ name: "enum", argument: r.enum, message: "is not one of enum values: " + r.enum.map(String).join(",") }), p;
    }, a.const = function(i, r, _, h) {
      if (i === void 0) return null;
      var p = new E(i, r, _, h);
      return n.deepCompareStrict(r.const, i) || p.addError({ name: "const", argument: r.const, message: "does not exactly match expected constant: " + r.const }), p;
    }, a.not = a.disallow = function(i, r, _, h) {
      var p = this;
      if (i === void 0) return null;
      var P = new E(i, r, _, h), c = r.not || r.disallow;
      return c ? (Array.isArray(c) || (c = [c]), c.forEach(function(I) {
        if (p.testType(i, r, _, h, I)) {
          var U = I && (I.$id || I.id) || I;
          P.addError({ name: "not", argument: U, message: "is of prohibited type " + U });
        }
      }), P) : null;
    }, Wt = A;
  })(), e = mt(), s = Yt().scan, o = e.ValidatorResult, l = e.ValidatorResultError, T = e.SchemaError, m = e.SchemaContext, v = function n() {
    this.customFormats = Object.create(n.prototype.customFormats), this.schemas = {}, this.unresolvedRefs = [], this.types = Object.create(N), this.attributes = Object.create(t.validators);
  };
  function C(n) {
    var E = typeof n == "string" ? n : n.$ref;
    return typeof E == "string" && E;
  }
  v.prototype.customFormats = {}, v.prototype.schemas = null, v.prototype.types = null, v.prototype.attributes = null, v.prototype.unresolvedRefs = null, v.prototype.addSchema = function(n, E) {
    var f = this;
    if (!n) return null;
    var A = s(E || "/", n), a = E || n.$id || n.id;
    for (var d in A.id) this.schemas[d] = A.id[d];
    for (var d in A.ref) this.unresolvedRefs.push(d);
    return this.unresolvedRefs = this.unresolvedRefs.filter(function(u) {
      return f.schemas[u] === void 0;
    }), this.schemas[a];
  }, v.prototype.addSubSchemaArray = function(n, E) {
    if (Array.isArray(E)) for (var f = 0; f < E.length; f++) this.addSubSchema(n, E[f]);
  }, v.prototype.addSubSchemaObject = function(n, E) {
    if (E && typeof E == "object") for (var f in E) this.addSubSchema(n, E[f]);
  }, v.prototype.setSchemas = function(n) {
    this.schemas = n;
  }, v.prototype.getSchema = function(n) {
    return this.schemas[n];
  }, v.prototype.validate = function(n, E, f, A) {
    if (typeof E != "boolean" && typeof E != "object" || E === null) throw new T("Expected `schema` to be an object or boolean");
    f || (f = {});
    var a = E.$id || E.id;
    let d = e.resolveUrl(f.base, a || "");
    if (!A) {
      (A = new m(E, f, [], d, Object.create(this.schemas))).schemas[d] || (A.schemas[d] = E);
      var u = s(d, E);
      for (var S in u.id) {
        var y = u.id[S];
        A.schemas[S] = y;
      }
    }
    var b;
    if (f.required && n === void 0) return (b = new o(n, E, f, A)).addError("is required, but is undefined"), b;
    if (!(b = this.validateSchema(n, E, f, A))) throw new Error("Result undefined");
    if (f.throwAll && b.errors.length) throw new l(b);
    return b;
  }, v.prototype.validateSchema = function(n, E, f, A) {
    var a = new o(n, E, f, A);
    if (typeof E == "boolean") E === !0 ? E = {} : E === !1 && (E = { type: [] });
    else if (!E) throw new Error("schema is undefined");
    if (E.extends) if (Array.isArray(E.extends)) {
      var d = { schema: E, ctx: A };
      E.extends.forEach(this.schemaTraverser.bind(this, d)), E = d.schema, d.schema = null, d.ctx = null, d = null;
    } else E = e.deepMerge(E, this.superResolve(E.extends, A));
    var u = C(E);
    if (u) {
      var S = this.resolve(E, u, A), y = new m(S.subschema, f, A.path, S.switchSchema, A.schemas);
      return this.validateSchema(n, S.subschema, f, y);
    }
    var b = f && f.skipAttributes || [];
    for (var i in E) if (!t.ignoreProperties[i] && b.indexOf(i) < 0) {
      var r = null, _ = this.attributes[i];
      if (_) r = _.call(this, n, E, f, A);
      else if (f.allowUnknownAttributes === !1) throw new T("Unsupported attribute: " + i, E);
      r && a.importErrors(r);
    }
    if (typeof f.rewrite == "function") {
      var h = f.rewrite.call(this, n, E, f, A);
      a.instance = h;
    }
    return a;
  }, v.prototype.schemaTraverser = function(n, E) {
    n.schema = e.deepMerge(n.schema, this.superResolve(E, n.ctx));
  }, v.prototype.superResolve = function(n, E) {
    var f = C(n);
    return f ? this.resolve(n, f, E).subschema : n;
  }, v.prototype.resolve = function(n, E, f) {
    if (E = f.resolve(E), f.schemas[E]) return { subschema: f.schemas[E], switchSchema: E };
    let A = new URL(E, "thismessage::/").hash;
    var a = A && A.length && E.substr(0, E.length - A.length);
    if (!a || !f.schemas[a]) throw new T("no such schema <" + E + ">", n);
    var d = e.objectGetPath(f.schemas[a], A.substr(1));
    if (d === void 0) throw new T("no such schema " + A + " located in <" + a + ">", n);
    return { subschema: d, switchSchema: E };
  }, v.prototype.testType = function(n, E, f, A, a) {
    if (a !== void 0) {
      if (a === null) throw new T('Unexpected null in "type" keyword');
      if (typeof this.types[a] == "function") return this.types[a].call(this, n);
      if (a && typeof a == "object") {
        var d = this.validateSchema(n, a, f, A);
        return d === void 0 || !(d && d.errors.length);
      }
      return !0;
    }
  };
  var N = v.prototype.types = {};
  return N.string = function(n) {
    return typeof n == "string";
  }, N.number = function(n) {
    return typeof n == "number" && isFinite(n);
  }, N.integer = function(n) {
    return typeof n == "number" && n % 1 == 0;
  }, N.boolean = function(n) {
    return typeof n == "boolean";
  }, N.array = function(n) {
    return Array.isArray(n);
  }, N.null = function(n) {
    return n === null;
  }, N.date = function(n) {
    return n instanceof Date;
  }, N.any = function(n) {
    return !0;
  }, N.object = function(n) {
    return n && typeof n == "object" && !Array.isArray(n) && !(n instanceof Date);
  }, Xt = v;
}
var Kt = (function() {
  if (ee) return pt;
  ee = 1;
  var t = pt.Validator = Re();
  return pt.ValidatorResult = mt().ValidatorResult, pt.ValidatorResultError = mt().ValidatorResultError, pt.ValidationError = mt().ValidationError, pt.SchemaError = mt().SchemaError, pt.SchemaScanResult = Yt().SchemaScanResult, pt.scan = Yt().scan, pt.validate = function(e, s, o) {
    return new t().validate(e, s, o);
  }, pt;
})();
const Q = (t, e) => {
  if (!e) return console.error({ name: "ValidationError", message: `unable to send request for ${t.id}: body missing` }), !1;
  try {
    if (!t.properties) return console.error({ name: "ValidationError", message: "Schema does not have any properties to validate", schema: t }), !1;
    const o = Object.entries(t.properties), l = Object.keys(e);
    if (o.length < l.length) return console.error({ name: "ValidationError", message: `unable to send request for ${t.id}: body has more properties (${l.length}) than schema (${o.length})` }), !1;
  } catch (o) {
    return console.error({ name: "ValidationError", message: `unable to send request for ${t.id}: unexpected error`, data: o }), !1;
  }
  const s = Kt.validate(e, t, { required: !0 });
  return s.valid || console.error({ name: "ValidationError", message: `unable to send request for ${t.id}: invalid body`, data: s.errors }), s.valid;
}, D = (t, e) => {
  const s = Kt.validate(e, t);
  return s.valid || console.error({ name: "ValidationError", message: `unable to send request for ${t.id}: invalid params`, data: s.errors }), s.valid;
}, ot = (t, e) => {
  const s = Kt.validate(e, t);
  return s.valid || console.error({ name: "ValidationError", message: `unable to send request for ${t.id}: invalid query`, data: s.errors }), s.valid;
}, Mt = (t) => {
  if (!t) return "";
  const e = {};
  for (const [s, o] of Object.entries(t)) o && (e[s] = o.toString());
  return Object.keys(e).length ? `?${new URLSearchParams(e).toString()}` : "";
};
var Ne = ((t) => (t.IndexSizeError = "IndexSizeError", t.HierarchyRequestError = "HierarchyRequestError", t.WrongDocumentError = "WrongDocumentError", t.InvalidCharacterError = "InvalidCharacterError", t.NoModificationAllowedError = "NoModificationAllowedError", t.NotFoundError = "NotFoundError", t.NotSupportedError = "NotSupportedError", t.InvalidStateError = "InvalidStateError", t.InUseAttributeError = "InUseAttributeError", t.SyntaxError = "SyntaxError", t.InvalidModificationError = "InvalidModificationError", t.NamespaceError = "NamespaceError", t.InvalidAccessError = "InvalidAccessError", t.SecurityError = "SecurityError", t.NetworkError = "NetworkError", t.AbortError = "AbortError", t.URLMismatchError = "URLMismatchError", t.QuotaExceededError = "QuotaExceededError", t.TimeoutError = "TimeoutError", t.InvalidNodeTypeError = "InvalidNodeTypeError", t.DataCloneError = "DataCloneError", t.EncodingError = "EncodingError", t.NotReadableError = "NotReadableError", t.UnknownError = "UnknownError", t.ConstraintError = "ConstraintError", t.DataError = "DataError", t.TransactionInactiveError = "TransactionInactiveError", t.ReadOnlyError = "ReadOnlyError", t.VersionError = "VersionError", t.OperationError = "OperationError", t.NotAllowedError = "NotAllowedError", t))(Ne || {});
const Ue = (t, e) => t instanceof DOMException && (t.name === "AbortError" ? (console.warn(e && e.reason ? e.reason : t), !0) : (console.debug("unhandled DOM exception"), console.error(t), !1)), Le = (t) => V((e) => {
  t({ type: "SET_USER_FEATURES", data: e });
}, [t]), re = { type: "SET_USER_FEATURES", action: (t, e) => ({ ...t, features: e }) }, Oe = (t) => V((e) => {
  t({ type: "SET_USER_TENANCY", data: e });
}, [t]), ae = { type: "SET_USER_TENANCY", action: (t, e) => ({ ...t, tenant: e }) }, Ce = (t) => V((e) => {
  t({ type: "SET_USER_TENANCY_SLUG", data: e });
}, [t]), ie = { type: "SET_USER_TENANCY_SLUG", action: (t, e) => ({ ...t, slug: e }) }, ge = (t) => V((e) => {
  t({ type: "SET_USER_TOKEN", data: e });
}, [t]), se = { type: "SET_USER_TOKEN", action: (t, e) => ({ ...t, Token: e }) }, be = (t) => V((e) => {
  t({ type: "SET_USER", data: e });
}, [t]), oe = { type: "SET_USER", action: (t, e) => ({ ...t, ...e }) }, De = (t, e) => {
  switch (e.type) {
    case oe.type:
      return oe.action(t, e.data);
    case re.type:
      return re.action(t, e.data);
    case ae.type:
      return ae.action(t, e.data);
    case ie.type:
      return ie.action(t, e.data);
    case se.type:
      return se.action(t, e.data);
  }
}, he = { tenant: "", slug: "", token: "", isLoggedIn: !1 }, Nt = () => {
  console.warn("unable to use state USER: state not setup");
}, He = { ...he, setUser: Nt, setUserTenant: Nt, setUserTenantSlug: Nt, setUserToken: Nt, setUserFeatures: Nt }, ce = de(He), Ve = () => ue(ce), no = ({ children: t }) => {
  const [e, s] = me(De, { ...he }), o = { ...e, setUser: be(s), setUserTenant: Oe(s), setUserTenantSlug: Ce(s), setUserToken: ge(s), setUserFeatures: Le(s) };
  return wt.jsx(ce.Provider, { value: o, children: t });
}, Lt = () => {
  const { token: t, slug: e } = Ve();
  return V(({ url: s, method: o, headers: l, body: T, signal: m, camel: v = !0, authRequired: C, tenantRequired: N }) => {
    if (C && (!t || N && !e)) {
      const E = { type: "process-error", status_code: -1, error_code: "ServiceNotReady", message: "unable to fetch data: token or tenant is not set" };
      return Promise.reject({ isError: !0, data: E });
    }
    const n = l ? { ...l } : {};
    return n.Accept || (n.Accept = "application/json"), n["Content-Type"] || (n["Content-Type"] = "application/json"), n["Content-Type"] === "multipart/form-data" && delete n["Content-Type"], n.Authorization = `Bearer ${t}`, n["x-curate-tenant-slug"] = e, n["x-request-id"] = window.crypto.randomUUID(), new Promise((E, f) => {
      const A = (a, d) => {
        const u = Ue(a, m), S = !d || we(d?.status, a);
        if (u || S || console.error(a), a.status_code) {
          const y = { isError: !0, data: { ...a, type: "http-error" } };
          f(y);
        } else
          f({ isError: !0, data: a });
      };
      fetch(s, { method: o, headers: n, body: T === void 0 ? null : n["Content-Type"] === "application/json" ? JSON.stringify(Se(T)) : T }).then((a) => {
        const d = /* @__PURE__ */ ((r) => (_) => {
          A(_, r);
        })(a);
        if (!a.ok) return void d({ status: a.status, statusText: a.statusText });
        const u = a.headers.get("Content-Type");
        if (!u)
          return void f({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "UnknownContentType", message: "unable to export planogram: missing content type from response", response: a } });
        const S = u.split(";")[0], y = (r) => {
          E({ isError: !1, data: v ? Te(r) : r });
        }, b = (r) => {
          E({ isError: !1, data: r });
        }, i = (r) => {
          E({ isError: !1, data: r });
        };
        switch (S) {
          case "text/csv":
          case "text/plain":
            a.text().then(b, f).catch(d);
            break;
          case "application/json":
            a.json().then(y, f).catch(d);
            break;
          case "application/zip":
            a.blob().then(i, f).catch(d);
            break;
          default:
            f({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "UnknownMediaType", message: `unable to export document assortment: media type ${S} is not supported`, response: a } });
            break;
        }
      }, A).catch(A);
    });
  }, [t, e]);
};
var L = ((t) => (t.GET = "GET", t.POST = "POST", t.PUT = "PUT", t.PATCH = "PATCH", t.DELETE = "DELETE", t))(L || {});
const Eo = ({ getEndpoint: t, preflightValidation: e, chunkSize: s = 6, onUpdate: o }) => {
  const l = Lt(), T = rt(!1), [m, v] = G(!1), [C, N] = G(!1), [n, E] = G(), [f, A] = G(), a = rt([]), d = rt([]), [u, S] = G([]), [y, b] = G(0), i = V((_) => {
    if (!_.length) return void console.warn("batch has nothing to process", u, _);
    const h = [];
    let p = !1, P = "", c = "";
    d.current = [];
    for (let I = 0, U = _.length; I < U; I++) {
      if (p = !e || e(_[I]), !p) {
        console.warn("batch request error: failed to pass preflightValidation", _[I]);
        break;
      }
      if (P = t(_[I]), !P) {
        p = !1, console.warn("batch request error: failed to create url", _[I]);
        break;
      }
      const g = new AbortController();
      d.current.push(g), c = Mt(_[I].query || {}), h.push({ ..._[I], url: c ? `${P}${c}` : P, method: L.GET, signal: g.signal });
    }
    h.length ? p ? (a.current = h.map((I) => l(I)), v(!0)) : console.warn("batch has invalid request") : console.debug("batch process does not have requests to send");
  }, [u, l, t, e]), r = V((_) => {
    _.length ? (N(!1), E(void 0), S(_), b(0)) : console.warn("batch request requires an list of params and/or queries");
  }, []);
  return X(() => {
    if (!u || !u.length) return;
    const _ = y, h = y + s, p = u.slice(_, h);
    p.length ? i(p) : console.warn("next batch empty", _, h, u);
  }, [u, y, s, i]), X(() => {
    m && a.current.length && Promise.allSettled(a.current).then((_) => {
      const h = [], p = [];
      _.forEach((c) => {
        c.status !== "rejected" ? c.value.isError ? h.push(c.value) : p.push(c.value.data) : h.push(c.reason);
      }), h.length && (A(h), console.warn(h)), E((c) => c ? (o && o(p.slice(), c.slice()), c.concat(p)) : (o && o(p.slice(), []), p));
      const P = y + s;
      P < u.length ? b(P) : (N(!0), v(!1));
    }).catch((_) => {
      A([_]), N(!0), v(!1);
    });
  }, [u.length, y, s, m, o]), X(() => (T.current = !0, () => {
    T.current = !1, d.current && d.current.length && d.current.forEach((_) => {
      _.abort();
    });
  }), []), [m, C, n, r, f];
}, Ge = ({ maxConcurrency: t = 8, getEndpoint: e, preflightValidation: s, method: o, headers: l, onFinish: T, onError: m, onResponse: v, onEmptyQueue: C }) => {
  const N = Lt(), n = rt(!1), E = rt(/* @__PURE__ */ new Map()), f = rt(null), [A, a] = G(!1), [d, u] = G(0), S = V((r) => {
    m && m(r);
  }, [m]), y = V(() => {
    u((r) => r + 1);
  }, []), b = V(() => {
    if (E.current.size < t && f.current !== null) {
      const p = performance.now().toFixed(0).toString();
      E.current.set(p, { args: f.current.args }), f.current.resolve(!0), f.current = null;
    }
    if (!E.current.size && !f.current) return y(), void a(!1);
    const r = Array.from(E.current.keys());
    let _ = 0;
    const h = [];
    for (a(!0); _ < r.length && E.current.size > 0; ) {
      const p = r[_], P = E.current.get(p);
      if (_++, !P) {
        E.current.delete(p);
        continue;
      }
      if (P.abortController) continue;
      if (!(!s || s(P.args))) {
        S({ name: "InvalidPreFlightValidation", details: P.args }), E.current.delete(p);
        continue;
      }
      const c = e(P.args);
      if (!c) {
        S({ name: "InvalidUrl", details: P.args }), E.current.delete(p);
        continue;
      }
      const I = new AbortController(), U = N({ url: c, method: o, headers: l, signal: I.signal, body: P.args.body });
      h.push(U), E.current.set(p, { args: P.args, abortController: I }), U.finally(() => {
        T && T({ params: P.args.params }), E.current.delete(p);
      });
    }
    Promise.race(h).then((p) => {
      v && v(p), b();
    }, S);
  }, [t, S, y, s, e, N, o, l, T, v]), i = V((r) => new Promise((_) => {
    if (E.current.size < t) {
      const h = performance.now().toFixed(0).toString();
      return E.current.set(h, { args: r }), b(), void _(!0);
    }
    f.current = { resolve: _, args: r };
  }), [t, b]);
  return X(() => {
    d && C && (C(d), u(0));
  }, [C, d]), X(() => (n.current = !0, () => {
    n.current = !1, E.current && E.current.size && (E.current.forEach((r) => {
      r.abortController && r.abortController.abort();
    }), E.current = /* @__PURE__ */ new Map());
  }), []), [A, i];
}, Me = (t, e, s, o) => {
  const l = t - e, T = Math.ceil(l / s);
  return T ? T - o > -1 ? o : T : -1;
}, Fe = ({ getEndpoint: t, pageLimit: e, chunkLimit: s, requestDelay: o, onUpdate: l, onComplete: T, onFailure: m }) => {
  const v = Lt(), C = rt(!1), N = rt(), [n, E] = G(), [f, A] = G(!1), [a, d] = G(), [u, S] = G([]), y = V(() => {
    N.current && N.current.abort(), n && clearTimeout(n);
  }, [n]), b = V((i, r, _ = !0) => {
    _ && y();
    const h = (({ response: c, direction: I = "next" }) => {
      if (!Object.hasOwn(c, I) || c[I] === void 0 || c[I] === null) return console.warn(`unable to get offset value: response has no ${I} url`, c), -1;
      const U = c[I];
      if (U == null || typeof U != "string") return console.warn(`unable to get offset value: response has no ${I} url`, c), -1;
      const g = new URL(U).searchParams.get("offset");
      if (!g) return console.warn("unable to get offset value: offset param missing from response next url", c), -1;
      const $ = parseInt(g);
      return isNaN($) ? (console.warn("unable to get offset value: offset param is not a number", c, g), -1) : $;
    })({ response: i });
    if (A(!0), h === -1) {
      if (i.count !== i.results.length) return void console.warn("unable to send request chunks: no offset", i, h);
      const c = [...u, ...i.results];
      return S(c), l && l(i.results, c), T && T(), void A(!1);
    }
    const p = Me(i.count, h, e, s);
    if (p === -1) return console.warn("unable to get next chunk: no chunks left", i, p), void A(!1);
    const P = setTimeout(() => {
      const c = [];
      N.current = new AbortController(), d(void 0);
      for (let I = 0; I < p; I++) {
        const U = t(r);
        if (!U) {
          const Y = { isError: !0, data: { type: "process-error", status_code: -1, error_code: "MalformedURL", message: "unable to DRAIN: url is missing" } };
          console.warn(Y, r), d(Y), A(!1);
          break;
        }
        let g = "";
        Object.hasOwn(r, "query") && (g = Mt({ ...r.query, offset: I * e + h, limit: e }));
        const $ = { ...r, url: `${U}${g}`, method: L.GET, signal: N.current.signal };
        c.push(v($));
      }
      Promise.allSettled(c).then((I) => {
        if (!C.current) return;
        const U = [], g = [];
        let $;
        if (I.forEach((x) => {
          x.status === "rejected" ? U.push(x.reason) : x.status === "fulfilled" && (x.value.isError ? U.push(x.value) : (g.push(...x.value.data.results), $ = x.value.data));
        }), !$) {
          const x = { isError: !0, data: { type: "process-error", status_code: -1, error_code: "NoLastChunk", message: "unable to get next chunk: chunks malformed" } };
          return U.push(x), d(U), void (m && m(U));
        }
        U.length && m && m(U);
        const Y = [...u, ...g];
        S(Y), l && l(g, Y), $.next ? b($, r) : (T && T(), A(!1));
      });
    }, o);
    E(P);
  }, [y, u, s, v, t, T, m, l, e, o]);
  return X(() => (C.current = !0, () => {
    C.current = !1, N.current?.abort();
  }), []), [f, u, b, a, y];
}, _o = ({ getEndpoint: t, preflightValidation: e, pageLimit: s = 100, chunkLimit: o = 2, requestDelay: l = 500, onUpdate: T, onComplete: m, onFailure: v }, C) => {
  const N = Lt(), n = rt(!1), E = rt(), [f, A] = G(!1), [a, d] = G(!1), u = rt([]), [S, y] = G(), [b, i] = G(), [r, _] = G(0), h = V((q) => {
    n.current && (u.current.push(...q), T && T(q, u.current), y([...u.current]));
  }, [T]), p = V((q) => {
    if (n.current) return Array.isArray(q) || q.isError ? (v && v(q), console.debug(q), i(q), d(!0), void A(!1)) : void (q.isError || (console.error("DRAIN request handling non-error in Error handler", q), d(!0), A(!1)));
  }, [v]), P = V(() => {
    m && m(), d(!0), A(!1);
  }, [m]), [c, I, U, g, $] = Fe({ getEndpoint: t, pageLimit: s, chunkLimit: o, requestDelay: l, onUpdate: h, onComplete: P, onFailure: p }), Y = V(() => {
    E.current && E.current.abort(), $();
  }, [$]), x = V((q) => (W) => {
    if (n.current) if (W.isError) p(W);
    else {
      if (u.current = [...W.data.results], _(W.data.count), y(u.current), !W.data.next) return d(!0), void A(!1);
      U(W.data, q);
    }
  }, [U, p]), ut = V((q, W = !0) => {
    if (W && Y(), A(!0), d(!1), _(0), u.current = [], !(!e || e(q)))
      return void p({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "PreflightValidation", message: "GET request did not pass preflight validation" } });
    const it = t(q);
    if (!it)
      return void p({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "MalformedURL", message: "unable to DRAIN: url is missing" } });
    const ht = Mt(q.query), ft = x(q);
    E.current = new AbortController();
    const It = { ...q, url: ht ? `${it}${ht}` : it, method: L.GET, signal: E.current.signal };
    i(void 0), N(It).then(ft, p).catch(p);
  }, [Y, N, t, p, x, e]);
  return X(() => {
    n.current = !0;
    const q = E.current?.abort;
    return () => {
      n.current = !1, q && q();
    };
  }, []), X(() => {
    !C || f || S || b || g || ut(C);
  }, [g, S, ut, b, C, f]), [f || c, a, S, r, ut, b || g];
}, O = ({ getEndpoint: t, preflightValidation: e, formatQuery: s, onSuccess: o, onFailure: l, method: T, authRequired: m = !0, tenantRequired: v = !0, headers: C }, N) => {
  const n = Lt(), E = rt(!1), f = rt(), [A, a] = G(!1), [d, u] = G(), [S, y] = G(), b = V((_) => {
    if (E.current) {
      if (_.isError) return l && l(_), y(_), void a(!1);
      if (o) {
        const h = o(_.data);
        u(h || _.data);
      } else u(_.data);
      a(!1);
    }
  }, [l, o]), i = V((_) => {
    console.debug(_), E.current && (_.isError && (y(_), l && l(_)), a(!1));
  }, [l]);
  V((_) => {
    f.current?.abort(_);
  }, []);
  const r = V((_, h = !0) => {
    const p = t(_);
    if (!p)
      return void console.warn({ error_code: "MalformedURL", message: "unable to send GET request: url is missing" }, _);
    const { params: P, query: c, body: I, ...U } = _;
    let g;
    if (typeof _.params != "boolean") {
      if (!(!e || e({ params: P, query: c, body: I })))
        return void console.warn({ error_code: "PreflightValidation", message: "GET request did not pass preflight validation" }, _);
      const Y = c ? s ? s(c) : c : void 0;
      g = { ...U, url: Y ? `${p}${Mt(Y)}` : p, method: T, body: I, authRequired: m, tenantRequired: v, headers: C };
    } else g = { url: p, method: T, authRequired: m, tenantRequired: v, headers: C };
    h && f.current?.abort();
    const $ = new AbortController();
    g.signal = $.signal, u(void 0), y(void 0), f.current = $, a(!0), n(g).then(b, i).catch(i);
  }, [t, n, b, i, e, s, T, m, v, C]);
  return X(() => {
    E.current = !0;
    const _ = f.current?.abort;
    return () => {
      E.current = !1, _ && _();
    };
  }, []), X(() => {
    !N || A || d || S || (typeof N.params != "boolean" || N.params) && r(N);
  }, [d, S, r, N, A]), at(() => [A, d, r, S], [A, d, r, S]);
}, we = (t, e) => t >= 200 && t <= 209 || t >= 300 && t <= 308 || (t >= 400 && t <= 429 ? (console.warn(e), !0) : t >= 500 && t <= 511 ? (console.error(e), !0) : (console.debug("unhandled HTTP Status"), console.error(e), !1)), Ye = ({ params: t }) => `https://platform.hivery.ai/api/v1/agent/assistants${t?.assistantId ? `/${t?.assistantId}` : ""}`, qe = { id: "ParamsGetAgentAssistants", type: "object", properties: { assistantId: { type: "string", required: !0 } }, required: !1 }, je = ({ params: t }) => D(qe, t), uo = (t, e) => O({ ...e, method: L.GET, getEndpoint: Ye, preflightValidation: je }, t), Ke = ({ params: t }) => {
  const e = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://platform.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" };
  if (t?.threadId && t?.messageId) return `${e.AGENT_API}/threads/${t.threadId}/messages/${t.messageId}`;
}, $e = { id: "ParamsGetAgentMessage", type: "object", properties: { threadId: { type: "string", required: !0 }, messageId: { type: "string", required: !0 } }, required: !1 }, Ze = ({ params: t }) => D($e, t), ho = (t, e) => O({ ...e, method: L.GET, getEndpoint: Ke, preflightValidation: Ze }, t), xe = ({ params: t }) => {
  const e = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://platform.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" };
  if (t?.threadId && t?.runId) return `${e.AGENT_API}/threads/${t.threadId}/runs/${t.runId}`;
}, ze = { id: "ParamsGetAgentRun", type: "object", properties: { threadId: { type: "string", required: !0 }, runId: { type: "string", required: !0 } }, required: !1 }, ke = ({ params: t }) => D(ze, t), co = (t, e) => O({ ...e, method: L.GET, getEndpoint: xe, preflightValidation: ke }, t), Be = ({ params: t }) => `https://platform.hivery.ai/api/v1/agent/threads${t?.threadId ? `/${t?.threadId}` : ""}`, We = { id: "ParamsGetAgentThreads", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, Je = ({ params: t }) => D(We, t), lo = (t, e) => O({ ...e, method: L.GET, getEndpoint: Be, preflightValidation: Je }, t), Qe = ({ params: t }) => {
  const e = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://platform.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" };
  if (t?.threadId) return `${e.AGENT_API}/threads/${t.threadId}/messages`;
}, Xe = { id: "ParamsListAgentMessages", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, tr = { id: "QueryListAgentMessages", type: "object", properties: { limit: { type: "number", required: !1, minimum: 1, maximum: 100 }, offset: { type: "number", required: !1, minimum: 1 } }, required: !1 }, er = ({ params: t, query: e }) => {
  const s = D(Xe, t);
  return s && ot(tr, e);
}, Ao = (t, e) => O({ ...e, method: L.GET, getEndpoint: Qe, preflightValidation: er }, t), rr = { SINGLE: "single_agent_assistant" }, ar = { SCENARIO: "scenario" }, ir = { USER: "user", ASSISTANT: "assistant" }, Io = { IN_PROGRESS: "in_progress", INCOMPLETE: "incomplete", COMPLETED: "completed" }, mo = { DIALOGUE: "dialogue", MONOLOGUE: "monologue", CHART: "chart" }, fo = { NOMINAL: "nominal" }, To = { BAR: "bar" }, So = { SVG: "image/svg+xml", HTML: "image/html" }, Po = { QUEUED: "queued", IN_PROGRESS: "in_progress", FAILED: "failed", COMPLETED: "completed" }, sr = () => "https://platform.hivery.ai/api/v1/agent/assistants", or = { id: "BodyPostAgentAssistant", type: "object", properties: { assistantConfig: { type: "object", required: !0, additionalProperties: !1, properties: { assistantType: { type: "string", required: !0, enum: [rr.SINGLE] } } }, description: { type: "string" } }, required: !0 }, pr = ({ body: t }) => Q(or, t), vo = (t) => O({ ...t, method: L.POST, getEndpoint: sr, preflightValidation: pr }), nr = ({ params: t }) => {
  const e = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://platform.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" };
  if (t?.threadId) return `${e.AGENT_API}/threads/${t.threadId}/messages`;
}, Er = { id: "ParamsPostAgentMessage", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, _r = { id: "BodyPostAgentMessage", type: "object", properties: { content: { type: "string", required: !0 }, role: { type: "string", required: !0, enum: [ir.USER] } }, required: !0 }, dr = ({ params: t, body: e }) => {
  const s = D(Er, t);
  return s && Q(_r, e);
}, yo = (t) => O({ ...t, method: L.POST, getEndpoint: nr, preflightValidation: dr }), ur = ({ params: t }) => {
  const e = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://platform.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" };
  if (t?.threadId) return `${e.AGENT_API}/threads/${t.threadId}/runs`;
}, hr = { id: "ParamsPostAgentRun", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, cr = { id: "ParamsPostAgentRun", type: "object", properties: { assistantId: { type: "string", required: !1 }, asyncMode: { type: "boolean", required: !1 } }, required: !1 }, lr = ({ params: t, body: e }) => {
  const s = D(hr, t);
  return s && Q(cr, e);
}, Ro = (t) => O({ ...t, method: L.POST, getEndpoint: ur, preflightValidation: lr }), Ar = () => "https://platform.hivery.ai/api/v1/agent/threads", Ir = { id: "BodyPostAgentThread", type: "object", properties: { scope: { type: "object", required: !0, additionalProperties: !1, properties: { scopeLevel: { type: "string", required: !0, enum: [ar.SCENARIO] }, tenantSlug: { type: "string", required: !0 }, projectId: { type: "number", required: !0 }, scenarioId: { type: "number", required: !0 } } } }, required: !0 }, mr = ({ body: t }) => Q(Ir, t), No = (t) => O({ ...t, method: L.POST, getEndpoint: Ar, preflightValidation: mr }), fr = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/assortment`;
}, Tr = { id: "ParamsGetAssortment", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Sr = ({ params: t }) => D(Tr, t), Uo = (t, e) => O({ ...e, method: L.GET, getEndpoint: fr, preflightValidation: Sr }, t), Pr = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/pods`;
}, vr = { id: "ParamsGetPODS", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, yr = ({ params: t, query: e }) => {
  const s = D(vr, t);
  if (!s) return s;
  const o = ["product_id", "store_id"];
  return e ? e.fields = e.fields ? [...o, ...e.fields] : o : e = { fields: o }, !0;
}, Lo = (t, e) => O({ ...e, method: L.GET, getEndpoint: Pr, preflightValidation: yr }, t), Rr = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/tasks/${t.taskId}/status`;
}, Nr = { id: "ParamsGetTasksStatus", type: "object", properties: { taskId: { type: "integer", required: !0 } }, required: !0 }, Ur = ({ params: t }) => D(Nr, t), Lr = (t, e) => O({ ...e, method: L.GET, getEndpoint: Rr, preflightValidation: Ur }, t);
var Pt = ((t) => (t.COMPLETED = "COMPLETED", t.PENDING = "PENDING", t.CANCELLED = "CANCELLED", t.STARTED = "STARTED", t.ERROR = "ERROR", t))(Pt || {});
const le = () => {
  const t = rt(), [e, s] = G(!1), [o, l] = G(), [T, m] = G(), [v, C] = G(!1), N = V((d) => {
    if (!o || !o.params)
      return m({ isError: !0, data: { type: "process-error", error_code: "ValidationError", status_code: -1, message: "unable to continue polling task status: request params missing", response: d } }), s(!1), d;
    switch (d.status) {
      case Pt.ERROR:
      case Pt.CANCELLED: {
        const u = { isError: !0, data: { type: "process-error", error_code: "ServerError", status_code: -1, message: `unable to continue polling task status: task resulted in ${d.status}: ${o.params.taskId}`, response: d } };
        m(u), s(!1);
        break;
      }
      case Pt.COMPLETED:
        s(!1);
        break;
      case Pt.PENDING:
      case Pt.STARTED:
        C(!0);
    }
    return d;
  }, [o]), n = V((d) => {
    m(d), s(!1);
  }, []), [E, f, A] = Lr(void 0, { onSuccess: N, onFailure: n }), a = V((d) => {
    s(!0), l(d), A(d);
  }, [A]);
  return X(() => {
    v && o && (C(!1), t.current = setTimeout(() => {
      A(o);
    }, 5e3));
  }, [A, v, o]), X(() => {
    const d = t.current;
    return () => {
      d && clearTimeout(d);
    };
  }, []), [e, f, a, T];
}, Or = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/stores/export_assortment`;
}, Cr = { id: "ParamsExportAssortment", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, gr = ({ params: t }) => D(Cr, t), Oo = () => {
  const [t, e] = G(!1), [s, o] = G(), [l, T] = G(), [m, v, C, N] = le(), n = V((u) => {
    if (typeof u == "string") o(u), e(!1);
    else if (u instanceof Object && Object.hasOwn(u, "taskId")) C({ params: { taskId: u.taskId } });
    else {
      const S = { isError: !0, data: { type: "process-error", error_code: "UnknownResponse", status_code: -1, message: "unknown response type from posting assortment request", response: u } };
      T(S), console.warn(S);
    }
    return u;
  }, [C]), E = V((u) => {
    T(u), e(!1);
  }, []), [f, A, a] = O({ method: L.POST, getEndpoint: Or, preflightValidation: gr, onSuccess: n, onFailure: E }), d = V((u) => {
    e(!0), a({ ...u, body: void 0 });
  }, [a]);
  return X(() => {
    m || (N ? console.warn(N) : (o(v), e(!1)));
  }, [m, v, N]), at(() => [t, s, d, l], [l, s, t, d]);
};
var br = ((t) => (t.ADDED = "added", t.REMOVED = "removed", t.RETAINED = "retained", t.EXCLUDED = "excluded", t))(br || {});
const Dr = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}`;
}, Hr = { id: "ParamsGetDocuments", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Vr = ({ params: t }) => D(Hr, t), Co = (t, e) => O({ ...e, method: L.GET, getEndpoint: Dr, preflightValidation: Vr }, t), Gr = ({ params: t, query: e }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/workspaces/${t.workspaceId}/documents/summaries`;
}, Mr = { id: "ParamsGetDocumentsSummaries", type: "object", properties: { workspaceId: { type: "integer", required: !0 } }, required: !0 }, Fr = ({ params: t, query: e }) => D(Mr, t), go = (t, e) => O({ ...e, method: L.GET, getEndpoint: Gr, preflightValidation: Fr }, t);
var wr = ((t) => (t.READY = "READY", t.BUSY = "BUSY", t))(wr || {});
const Yr = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/edit_requests/most_recent`;
}, qr = { id: "ParamsGetEditRequestsMostRecent", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, jr = ({ params: t }) => D(qr, t), Kr = (t, e) => O({ ...e, method: L.GET, getEndpoint: Yr, preflightValidation: jr }, t);
var qt = ((t) => (t.pending = "PENDING", t.error = "ERROR", t.completed = "COMPLETED", t))(qt || {}), dt = ((t) => (t.drop = "DROP_POSITION", t.dropProduct = "DROP_PRODUCT", t.insert = "INSERT_POSITION", t.insertProduct = "INSERT_PRODUCT", t.move = "MOVE_POSITION", t.setFacings = "SET_POSITION_FACINGS", t.setProduct = "SET_POSITION_PRODUCT", t.swap = "SWAP_POSITION", t.swapProduct = "SWAP_PRODUCT", t.insertProductBulk = "INSERT_POSITION_BULK", t.dropPositionBulk = "DROP_POSITION_BULK", t))(dt || {});
const $r = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/edit_requests`;
}, Zr = { id: "ParamsPostEditRequestsCreate", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, xr = ({ params: t }) => D(Zr, t), At = () => {
  const [t, e] = G(!1), [s, o] = G(), [l, T] = G(), m = V((y) => {
    o(y), e(!1);
  }, []), v = V((y) => (e(!1), y), []), [C, N, n, E] = O({ method: L.POST, getEndpoint: $r, preflightValidation: xr, onFailure: m, onSuccess: v }), f = V((y) => {
    switch (y.status) {
      case qt.completed:
        if (!l || !l.body) {
          o({ isError: !0, data: { type: "process-error", error_code: "ValidationError", status_code: -1, message: "unable to create edit request: edit request data is missing" } }), e(!1);
          break;
        }
        n({ ...l, body: { ...l.body, version: y.version + 1 } }), e(!1);
        break;
      case qt.error:
        o({ isError: !0, data: { type: "process-error", error_code: "ServerError", status_code: -1, message: "unable to create edit request: most recent request encountered an error", response: y } }), e(!1);
        break;
    }
    return y;
  }, [n, l]), [A, a, d, u] = Kr(void 0, { onFailure: m, onSuccess: f }), S = V((y) => {
    y.params ? (e(!0), o(void 0), T(y), d({ params: { documentId: y.params.documentId } })) : console.debug("unable to send edit request: params missing");
  }, [d]);
  return at(() => [t, N, S, s], [N, s, t, S]);
}, bo = () => {
  const [t, e, s, o] = At(), l = V(({ params: T, body: m }) => {
    if (!T || !m) return;
    const v = { version: 1, commandType: dt.drop, parameters: m };
    s({ params: T, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, l, o], [t, l, e, o]);
}, Do = () => {
  const [t, e, s, o] = At(), l = V(({ params: T, body: m }) => {
    if (!T || !m) return;
    const v = { version: 1, commandType: dt.dropProduct, parameters: m };
    s({ params: T, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, l, o], [t, l, e, o]);
}, Ho = () => {
  const [t, e, s, o] = At(), l = V(({ params: T, body: m }) => {
    if (!T || !m) return;
    const v = { version: 1, commandType: dt.insert, parameters: m };
    s({ params: T, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, l, o], [t, l, e, o]);
}, Vo = () => {
  const [t, e, s, o] = At(), l = V(({ params: T, body: m }) => {
    if (!T || !m) return;
    const v = { version: 1, commandType: dt.insertProduct, parameters: m };
    s({ params: T, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, l, o], [t, l, e, o]);
}, Go = () => {
  const [t, e, s, o] = At(), l = V(({ params: T, body: m }) => {
    if (!T || !m) return;
    const v = { version: 1, commandType: dt.move, parameters: m };
    s({ params: T, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, l, o], [t, l, e, o]);
}, Mo = () => {
  const [t, e, s, o] = At(), l = V(({ params: T, body: m }) => {
    if (!T || !m) return;
    const v = { version: 1, commandType: dt.setFacings, parameters: m };
    s({ params: T, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, l, o], [t, l, e, o]);
}, Fo = () => {
  const [t, e, s, o] = At(), l = V(({ params: T, body: m }) => {
    if (!T || !m) return;
    const v = { version: 1, commandType: dt.swap, parameters: m };
    s({ params: T, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, l, o], [t, l, e, o]);
}, wo = () => {
  const [t, e, s, o] = At(), l = V(({ params: T, body: m }) => {
    if (!T || !m) return;
    const v = { version: 1, commandType: dt.swapProduct, parameters: m };
    s({ params: T, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, l, o], [t, l, e, o]);
}, zr = () => "https://platform.hivery.ai/api/v2/ssdi/test-auth", Yo = (t, e) => O({ ...e, method: L.GET, getEndpoint: zr }, t), Ae = { MOVEMENT: "movement", PRODUCT: "product", PRODUCT_INNOVATIONS: "product_innovations", LOCATION: "location", LOCATION_INNOVATIONS: "location_innovations", LOCATION_PLANOGRAMS: "location_planograms", AVAILABILITY: "availability", PLANOGRAMS: "planograms" }, qo = { PENDING: "pending", RESOLVING: "resolving", SUCCEEDED: "succeeded", FAILED: "failed", CANCELLED: "cancelled" }, kr = () => "https://platform.hivery.ai/api/v2/ssdi/files", Br = { id: "BodyPostFilesUpload", type: "object", properties: { kind: { type: "string", required: !0, enum: Object.values(Ae) }, name: { type: "string", required: !0 } }, required: !0 }, Wr = ({ body: t }) => Q(Br, t), Jr = (t) => O({ ...t, method: L.POST, getEndpoint: kr, preflightValidation: Wr }), Qr = ({ params: t }) => {
  if (t) return `https://platform.hivery.ai/api/v2/ssdi/files/${t.id}/upload-complete`;
}, Xr = { id: "ParamsPostFilesUploadComplete", type: "object", properties: { id: { type: "string", required: !0 } }, required: !1 }, ta = { id: "BodyPostFilesUploadComplete", type: "object", properties: { filePartIds: { type: "array", required: !0, minItems: 1, items: { type: "string" }, additionalItems: !1 }, kind: { type: "string", required: !0, enum: Object.values(Ae) }, ext: { type: "string", required: !0 } }, required: !0 }, ea = ({ params: t, body: e }) => {
  const s = D(Xr, t);
  return s && Q(ta, e);
}, ra = (t) => O({ ...t, method: L.POST, getEndpoint: Qr, preflightValidation: ea }), aa = ({ params: t }) => {
  if (t) return `https://platform.hivery.ai/api/v2/ssdi/files/${t.id}/upload-part/${t.part_number}`;
}, ia = { id: "ParamsPostFilesUploadPart", type: "object", properties: { id: { type: "string", required: !0 }, part_number: { type: "number", required: !0 } }, required: !1 }, sa = ({ params: t }) => D(ia, t), oa = (t) => {
  let e = { "Content-Type": "multipart/form-data" };
  return t && t.headers && (e = { ...t.headers, ...e }, delete t.headers), Ge({ ...t, method: L.POST, getEndpoint: aa, preflightValidation: sa, headers: e });
}, pa = () => "https://platform.hivery.ai/api/v1/curate/preferences", jo = (t = !0, e) => O({ ...e, method: L.GET, getEndpoint: pa, tenantRequired: !1 }, { params: t }), na = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/products/${t.productId}`;
}, Ea = { id: "ParamsGetCurateProduct", type: "object", properties: { productId: { type: "integer", required: !0 } }, required: !0 }, _a = ({ params: t }) => {
  const e = D(Ea, t);
  return !!e || e;
}, Ko = (t, e) => O({ ...e, method: L.GET, getEndpoint: na, preflightValidation: _a }, t), da = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/scenarios/${t.scenarioId}/national-results`;
}, ua = { id: "ParamsGetCurateProductSummaries", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, ha = { id: "QueryGetCurateProductSummaries", type: "object", properties: { ordering: { type: "string", required: !0 } }, required: !0 }, ca = ({ params: t, query: e }) => {
  const s = D(ua, t);
  if (!s) return s;
  const o = ot(ha, e);
  return !!o || o;
}, $o = (t, e) => O({ ...e, method: L.GET, getEndpoint: da, preflightValidation: ca }, t), la = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/products/summaries`;
}, Aa = { id: "ParamsGetProductSummaries", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Ia = { id: "QueryGetProductSummaries", type: "object", properties: { group_by: { type: "string", required: !0, minLength: 1 } }, required: !0 }, ma = ({ params: t, query: e }) => {
  const s = D(Aa, t);
  if (!s) return s;
  const o = ot(Ia, e);
  return !!o || o;
}, Zo = (t, e) => O({ ...e, method: L.GET, getEndpoint: la, preflightValidation: ma }, t), fa = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/projects/${t.projectId}/products${t.productId ? `/${t.productId}` : ""}`;
}, Ta = { id: "ParamsGetProducts", type: "object", properties: { projectId: { type: "integer", required: !0 }, productId: { type: "integer", required: !1 } }, required: !0 }, Sa = ({ params: t }) => D(Ta, t), xo = (t, e) => O({ ...e, method: L.GET, getEndpoint: fa, preflightValidation: Sa }, t), Pa = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/projects/${t.projectId}`;
}, va = { id: "ParamsDeleteProjects", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, ya = ({ params: t }) => D(va, t), zo = (t, e) => O({ ...e, method: L.DELETE, getEndpoint: Pa, preflightValidation: ya }, t), Ra = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/data-details`;
}, Na = { id: "ParamsGetProjectDataDetails", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, Ua = ({ params: t }) => D(Na, t), ko = (t, e) => O({ ...e, method: L.GET, getEndpoint: Ra, preflightValidation: Ua }, t);
var La = ((t) => (t.SUCCESS = "success", t.PENDING = "pending", t.PROCESSING = "processing", t.FAILED = "failed", t))(La || {}), Ut = ((t) => (t.PSA = "PSA", t.PTS = "PTS", t))(Ut || {});
const pe = { UPDATED_ASC: "+updated_on", UPDATED_DES: "-updated_on" }, Oa = { FORECASTS: "forecasts", PRODUCTS: "products", STORES: "stores", SUPPLIERS: "suppliers", PLANOGRAMS: "planograms", C13NS: "c13ns" }, Bo = { PENDING: "pending", SUCCESS: "success", UNKNOWN: "", DONE: "done", PROCESSING: "processing" }, Ca = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/projects/${t.projectId}/export-url/${t.fileType}`;
}, ga = { id: "ParamsGetProjectExportUrl", type: "object", properties: { projectId: { type: "integer", required: !0 }, fileType: { type: "string", required: !0, enum: Object.values(Oa) } }, required: !0 }, ba = ({ params: t }) => D(ga, t), Wo = (t, e) => O({ ...e, method: L.GET, getEndpoint: Ca, preflightValidation: ba }, t), Da = () => "https://platform.hivery.ai/api/v1/curate/projects/file-upload-config", Jo = (t = !0, e) => O({ ...e, method: L.GET, getEndpoint: Da }, { params: t }), Ha = ({ params: t }) => `https://platform.hivery.ai/api/v1/curate/projects${t?.projectId ? `/${t?.projectId}` : ""}`, Va = { id: "ParamsGetProjects", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !1 }, Ga = { id: "QueryGetProjects", type: "object", properties: { search: { type: "string", required: !1 }, limit: { type: "number", required: !1, minimum: 1, maximum: 100 }, offset: { type: "number", required: !1, minimum: 1 }, ordering: { type: "string", required: !0, enum: [pe.UPDATED_ASC, pe.UPDATED_DES] } }, required: !1 }, Ma = ({ params: t, query: e }) => t && Object.hasOwn(t, "projectId") ? D(Va, t) : ot(Ga, e), Qo = (t, e) => O({ ...e, method: L.GET, getEndpoint: Ha, preflightValidation: Ma }, t), Fa = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/projects/${t.projectId}`;
}, wa = { id: "ParamsPatchProject", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, Ya = { id: "BodyPatchProject", type: "object", properties: { isArchive: { type: "boolean", required: !0 } } }, qa = ({ params: t, body: e }) => {
  const s = D(wa, t);
  if (!s) return s;
  const o = Q(Ya, e);
  return !!o || o;
}, Xo = (t) => O({ ...t, method: L.PATCH, getEndpoint: Fa, preflightValidation: qa }), ja = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/settings`;
}, Ka = { id: "ParamsPatchProjectSettings", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, $a = { id: "BodyPatchProjectSettings", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 }, storesFile: { type: "string", required: !0, minLength: 1 }, productsFile: { type: "string", required: !0, minLength: 1 }, forecastsFile: { type: "string", required: !0, minLength: 1 }, suppliersFile: { type: "string", required: !0, minLength: 1 }, planogramsFile: { type: "string", required: !0, minLength: 0 }, planogramsFileFormat: { type: "string", enum: [Ut.PSA, Ut.PTS] }, planogramsFileNamingConvention: { type: "string", required: !0, minLength: 0 }, c13nsFile: { type: "string", required: !0, minLength: 0 }, changeC13nsFile: { type: "boolean", required: !0 } } }, Za = ({ params: t, body: e }) => {
  const s = D(Ka, t);
  if (!s) return s;
  const o = Q($a, e);
  return !!o || o;
}, tp = (t) => O({ ...t, method: L.PATCH, getEndpoint: ja, preflightValidation: Za }), ne = { SPACE: "space", ASSORTMENT: "assortment" }, ep = { FORCE_PODS_IN: "force_pods_in", FORCE_PODS_OUT: "force_pods_out", POD_PRESENCE: "pod_presence", TARGET_PODS: "target_pods", TARGET_QUANTITY_SOLD: "target_quantity_sold", TARGET_REVENUE: "target_revenue", TARGET_DISTRIBUTION: "target_distribution", TARGET_PRODUCT_SLOTTING: "target_product_slotting", PROTECT_PODS: "protect_pods", PARENT_RELATIONSHIP: "parent_relationship", LIMIT_ASSORTMENT_CHURN: "limit_assortment_churn", SPECIFY_ASSORTMENT_PRIORITY: "specify_assortment_priority" }, rp = { ADJUST_AVAILABILITY: "adjust_availability", ADJUST_QUANITY_SOLD: "adjust_quantity_sold", ADJUST_REVENUE: "adjust_revenue", ADJUST_RANKING_PRIORITY: "adjust_ranking_priority", ADJUST_OBJECTIVE_VALUE: "adjust_objective_value" }, ap = { SPECIFY_UNIT_CAPACITY: "specify_unit_capacity", SPECIFTY_CASE_CAPACITY: "specify_case_capacity", RESTRICT_UNSALEABLES: "restrict_unsaleables", SPECIFY_DOS_THRESHOLD: "specify_dos_threshold", DOS_BOOST: "dos_boost", CONTROL_FACINGS_FOR_ORIENTATION: "control_facings_for_orientation", LIMIT_SPACE_CHURN: "limit_space_churn", SPACE_ALLOCATION: "space_allocation" }, ip = { MATCH_PLACEMENT_HIERARCHICAL: "match_placement_hierarchical", ALLOWABLE_FIXTURE_TYPES: "allowable_fixture_types", ORIENTATIONS_FOR_MERCH_STYLE: "orientations_for_merch_style", SPECIFY_HEIGHT_FOR_STYLE: "specify_height_for_style", MAXIMUM_STACK_HEIGHT_FOR_STYLE: "maximum_stack_height_for_style", ALLOWED_MERCHANDIZE_STYLES: "allowed_merchandise_styles", SPECIFY_PLACEMENT_RANGE: "specify_placement_range" }, sp = { RELATIVE_POSITIONING: "relative_positioning", SINGLE_SHELF: "single_shelf", SINGLE_SEGMENT: "single_segment", SINGLE_LEVEL: "single_level", DISALLOW_PRESENCE: "disallow_presence", CHAIN_FLOW: "chain_flow", CONTROL_ALIGNMENT: "control_alignment", CONTROL_OVER_UNDERS: "control_over_unders" }, xa = () => "https://platform.hivery.ai/api/v1/curate/projects", za = { id: "BodyPostProject", type: "object", properties: { algorithmTypes: { type: "array", required: !0, minItems: 1, items: { type: "string", enum: [ne.ASSORTMENT, ne.SPACE] }, additionalItems: !1 }, name: { type: "string", required: !0, minLength: 1 }, storesFile: { type: "string", required: !0, minLength: 1 }, productsFile: { type: "string", required: !0, minLength: 1 }, forecastsFile: { type: "string", required: !0, minLength: 1 }, suppliersFile: { type: "string", required: !0, minLength: 1 }, planogramsFile: { type: "string", required: !0, minLength: 0 }, planogramsFileFormat: { type: "string", enum: [Ut.PSA, Ut.PTS] }, planogramsFileNamingConvention: { type: "string", required: !0, minLength: 0 }, c13nsFile: { type: "string", required: !0, minLength: 0 }, c13nModelId: { type: "string", required: !0, minLength: 0 }, isCannibalisationOnly: { type: "boolean", required: !0 }, parameters: { type: "object", required: !0, properties: { podThresholds: { type: "string", required: !0, minLength: 0 }, productFlow: { type: "string", required: !0, minLength: 0 }, rankingWeights: { type: "string", required: !0, minLength: 0 } }, additionalProperties: !1 } } }, ka = ({ body: t }) => Q(za, t), op = (t) => O({ ...t, method: L.POST, getEndpoint: xa, preflightValidation: ka }), Ba = () => "https://platform.hivery.ai/api/v1/curate/constraint-types", Wa = { id: "QueryGetConstraintTypes", type: "object", properties: { algorithm_types: { type: "string", required: !0 } }, required: !1 }, Ja = ({ query: t }) => ot(Wa, t), pp = (t, e) => O({ ...e, method: L.GET, getEndpoint: Ba, preflightValidation: Ja }, t), Qa = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios/${t.scenarioId}`;
}, Xa = { id: "ParamsDeleteScenario", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, ti = ({ params: t }) => D(Xa, t), np = (t, e) => O({ ...e, method: L.DELETE, getEndpoint: Qa, preflightValidation: ti }, t), ei = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/reviews${t.reviewId ? `/${t.reviewId}` : ""}`;
}, ri = { id: "ParamsGetReviews", type: "object", properties: { reviewId: { type: "integer", required: !1 } }, required: !1 }, ai = ({ params: t }) => D(ri, t), Ep = (t, e) => O({ ...e, method: L.GET, getEndpoint: ei, preflightValidation: ai }, t), ii = () => "https://platform.hivery.ai/api/v1/curate/scenarios/aggregation-options", _p = (t = !0, e) => O({ ...e, method: L.GET, getEndpoint: ii }, { params: t }), si = () => "https://platform.hivery.ai/api/v1/curate/scenarios/file-upload-config", dp = (t = !0, e) => O({ ...e, method: L.GET, getEndpoint: si }, { params: t }), oi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenario-groups${t.groupId ? `/${t.groupId}` : ""}`;
}, pi = { id: "ParamsGetScenarioGroups", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !1 } }, required: !0 }, ni = ({ params: t }) => D(pi, t), up = (t, e) => O({ ...e, method: L.GET, getEndpoint: oi, preflightValidation: ni }, t);
var Ei = ((t) => (t.SUCCESS = "success", t.SUCCESS_WITH_INFEASIBILITY = "success_with_inf", t.UNOPTIMISED = "unoptimised", t.PEDNING = "pending", t.PROCESSING = "processing", t.PROCESSING_UNPOLLABLE = "processing_unpollable", t.FAILED = "failed", t))(Ei || {}), _i = ((t) => (t.JOB_QUEUED = "job_queued", t.LOADING_DATA = "loading_data", t.SOLVING_MODEL = "solving_model", t.SAVING_RESULTS = "saving_results", t.PROCESSING = "processing", t.FAILED = "failed", t))(_i || {}), di = ((t) => (t.RULE = "rules_based", t.IE = "interactive", t))(di || {}), ui = ((t) => (t.IMPORT_PENDING = "import_pending", t.IMPORT_PROCESSING = "import_processing", t.IMPORT_FAILED = "import_failed", t.EDIT_PENDING = "edit_pending", t.EDIT_FAILED = "edit_failed", t.READY = "ready", t.SAVED = "saved", t))(ui || {});
const Vt = { PRODUCT_ASC: "product", PRODUCT_DES: "-product", UPC_ASC: "product_upc", UPC_DES: "-product_upc" }, hi = { BRAND: "brand", SUB_BRAND: "subbrand", CATEGORY: "category", SUB_CATEGORY: "subcategory", SUB_SUB_CATEGORY: "subsubcategory", MANUFACTURER: "manufacturer", PACK_GROUP: "packgroup", PRODUCT_UPC: "product_upc", PRODUCT_GROUP: "product_group" }, ci = ({ params: t, query: e }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/scenarios/${t.scenarioId}/national-results`;
}, li = { id: "ParamsGetScenariosNationalResults", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, Ai = { id: "QueryGetScenariosNationalResults", type: "object", properties: { ordering: { type: "string", required: !1, enum: [Vt.PRODUCT_ASC, Vt.PRODUCT_DES, Vt.UPC_ASC, Vt.UPC_DES] }, groupings: { type: "array", required: !1, items: { type: "string", uniqueItems: !0, enum: Object.entries(hi).map((t, e) => e) } } } }, Ii = ({ params: t, query: e }) => {
  const s = D(li, t);
  if (!s) return s;
  const o = ot(Ai, e);
  return !!o || o;
}, mi = (t) => {
  const e = {};
  return t.ordering && (e.ordering = t.ordering), t.groupBy && (e["group-by"] = t.groupBy.join(",")), e;
}, hp = (t, e) => O({ ...e, method: L.GET, getEndpoint: ci, preflightValidation: Ii, formatQuery: mi }, t), fi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios${t.scenarioId ? `/${t.scenarioId}` : ""}`;
}, Ti = { id: "ParamsGetScenarios", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !1 } }, required: !0 }, Si = ({ params: t }) => D(Ti, t), cp = (t, e) => O({ ...e, method: L.GET, getEndpoint: fi, preflightValidation: Si }, t), Pi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios-base-core`;
}, vi = { id: "ParamsGetScenariosBaseCore", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, yi = ({ params: t }) => D(vi, t), lp = (t, e) => O({ ...e, method: L.GET, getEndpoint: Pi, preflightValidation: yi }, t), Ri = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios/${t.reviewId}`;
}, Ni = { id: "ParamsPatchReview", type: "object", properties: { projectId: { type: "integer", required: !0 }, reviewId: { type: "integer", required: !0 } }, required: !0 }, Ui = { id: "BodyPatchReview", type: "object", properties: { isArchived: { type: "boolean", required: !0 } } }, Li = ({ params: t, body: e }) => {
  const s = D(Ni, t);
  if (!s) return s;
  const o = Q(Ui, e);
  return !!o || o;
}, Ap = (t) => O({ ...t, method: L.PATCH, getEndpoint: Ri, preflightValidation: Li }), Oi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios/${t.scenarioId}`;
}, Ci = { id: "ParamsPatchScenario", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, gi = ({ params: t }) => D(Ci, t), Ip = (t) => O({ ...t, method: L.PATCH, getEndpoint: Oi, preflightValidation: gi }), bi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios/${t.scenarioId}/assign-group`;
}, Di = { id: "ParamsPatchScenarioAssignGroup", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, Hi = { id: "BodyPatchScenarioGroupRename", type: "object", properties: { groupId: { type: "string", required: !0, minLength: 1 } } }, Vi = ({ params: t, body: e }) => {
  const s = D(Di, t);
  if (!s) return s;
  const o = Q(Hi, e);
  return !!o || o;
}, mp = (t) => O({ ...t, method: L.PATCH, getEndpoint: bi, preflightValidation: Vi }), Gi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenario-groups/${t.groupId}/archive`;
}, Mi = { id: "ParamsPatchScenarioGroupArchive", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !0 } }, required: !0 }, Fi = ({ params: t }) => D(Mi, t), fp = (t) => O({ ...t, method: L.PATCH, getEndpoint: Gi, preflightValidation: Fi }), wi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenario-groups/${t.groupId}/undo-archive`;
}, Yi = { id: "ParamsPatchScenarioGroupArchiveUndo", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !0 } }, required: !0 }, qi = ({ params: t }) => D(Yi, t), Tp = (t) => O({ ...t, method: L.PATCH, getEndpoint: wi, preflightValidation: qi }), ji = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenario-groups/${t.groupId}/rename`;
}, Ki = { id: "ParamsPatchScenarioGroupRename", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !0 } }, required: !0 }, $i = { id: "BodyPatchScenarioGroupRename", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 } } }, Zi = ({ params: t, body: e }) => {
  const s = D(Ki, t);
  if (!s) return s;
  const o = Q($i, e);
  return !!o || o;
}, Sp = (t) => O({ ...t, method: L.PATCH, getEndpoint: ji, preflightValidation: Zi }), xi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/scenarios/${t.scenarioId}/push_to_review`;
}, zi = { id: "ParamsPostReview", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, ki = { id: "BodyPostReview", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 } } }, Bi = ({ params: t, body: e }) => {
  const s = D(zi, t);
  if (!s) return s;
  const o = Q(ki, e);
  return !!o || o;
}, Pp = (t) => O({ ...t, method: L.POST, getEndpoint: xi, preflightValidation: Bi }), Wi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenario-groups`;
}, Ji = { id: "ParamsPostScenarioGroups", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, Qi = { id: "BodyPostScenarioGroups", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 }, orderIndex: { type: "number", required: !0 } } }, Xi = ({ params: t, body: e }) => {
  const s = D(Ji, t);
  if (!s) return s;
  const o = Q(Qi, e);
  return !!o || o;
}, vp = (t) => O({ ...t, method: L.POST, getEndpoint: Wi, preflightValidation: Xi }), ts = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/clusters/${t.clusterId}/planograms`;
}, es = { id: "ParamsGetClusterPlanograms", type: "object", properties: { documentId: { type: "integer", required: !0 }, clusterId: { type: "integer", required: !0 } }, required: !0 }, rs = ({ params: t }) => D(es, t), yp = (t, e) => O({ ...e, method: L.GET, getEndpoint: ts, preflightValidation: rs }, t), as = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/scenarios/${t.scenarioId}/store-results/${t.storeId}`;
}, is = { id: "ParamsGetCurateStoreProducts", type: "object", properties: { scenarioId: { type: "integer", required: !0 }, storeId: { type: "integer", required: !0 } }, required: !0 }, ss = { id: "QueryGetCurateProductSummaries", type: "object", properties: { ordering: { type: "string", required: !0 } }, required: !0 }, os = ({ params: t, query: e }) => {
  const s = D(is, t);
  if (!s) return s;
  const o = ot(ss, e);
  return !!o || o;
}, Rp = (t, e) => O({ ...e, method: L.GET, getEndpoint: as, preflightValidation: os }, t), ps = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios/${t.scenarioId}/store-list`;
}, ns = { id: "ParamsGetCurateStores", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, Es = { id: "QueryGetCurateProductSummaries", type: "object", properties: { offset: { type: "integer", required: !0 }, limit: { type: "integer", required: !0 }, ordering: { type: "string", required: !0 }, direction: { type: "string", required: !0 }, agg_vals: { type: "string", required: !0 }, aggregation: { type: "string", required: !0 } }, required: !0 }, _s = ({ params: t, query: e }) => {
  const s = D(ns, t);
  if (!s) return s;
  const o = ot(Es, e);
  return !!o || o;
}, Np = (t, e) => O({ ...e, method: L.GET, getEndpoint: ps, preflightValidation: _s }, t), ds = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/stores/kpi_summary`;
}, us = { id: "ParamsGetStoreKpiSummaries", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, hs = ({ params: t }) => D(us, t), Up = (t, e) => O({ ...e, method: L.GET, getEndpoint: ds, preflightValidation: hs }, t), cs = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/stores/${t.storeId}/planograms`;
}, ls = { id: "ParamsGetStoresPlanograms", type: "object", properties: { documentId: { type: "integer", required: !0 }, storeId: { type: "integer", required: !0 } }, required: !0 }, As = ({ params: t }) => D(ls, t), Lp = (t, e) => O({ ...e, method: L.GET, getEndpoint: cs, preflightValidation: As }, t), Is = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/stores/summaries`;
}, ms = { id: "ParamGetStoresSummaries", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, fs = { id: "QueryGetStoreSummaries", type: "object", properties: { group_by: { type: "string", required: !0, minLength: 1 } }, required: !0 }, Ts = ({ params: t, query: e }) => {
  const s = D(ms, t);
  if (!s) return s;
  const o = ot(fs, e);
  return !!o || o;
}, Op = (t, e) => O({ ...e, method: L.GET, getEndpoint: Is, preflightValidation: Ts }, t), Ss = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/stores/planograms-export`;
}, Ps = { id: "ParamsPostExportPlanograms", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, vs = ({ params: t }) => D(Ps, t), Cp = () => {
  const [t, e] = G(!1), [s, o] = G(), [l, T] = G(), [m, v, C, N] = le(), n = V((u) => {
    if (typeof u == "string") o(u), e(!1);
    else if (u instanceof Object && Object.hasOwn(u, "taskId")) C({ params: { taskId: u.taskId } });
    else {
      const S = { isError: !0, data: { type: "process-error", error_code: "UnknownResponse", status_code: -1, message: "unknown response type from posting assortment request", response: u } };
      T(S), console.warn(S);
    }
    return u;
  }, [C]), E = V((u) => {
    T(u), e(!1);
  }, []), [f, A, a] = O({ method: L.POST, getEndpoint: Ss, preflightValidation: vs, onSuccess: n, onFailure: E }), d = V((u) => {
    e(!0), a({ ...u, body: void 0 });
  }, [a]);
  return X(() => {
    m || (N ? console.warn(N) : (o(v), e(!1)));
  }, [m, v, N]), at(() => [t, s, d, l], [l, s, t, d]);
};
var ys = ((t) => (t.UNIT = "UNIT", t.TRAY = "TRAY", t.CASE = "CASE", t.DISPLAY = "DISPLAY", t.ALTERNATE = "ALTERNATE", t))(ys || {}), Rs = ((t) => (t.FIXTURE = "Fixture", t.SHELF = "Shelf", t.FLOATING = "FloatingShelf", t))(Rs || {});
const Ns = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/strategies/${t.strategy_id}/aggregation`;
}, Us = { id: "ParamsGetStrategyAggregation", type: "object", properties: { strategy_id: { type: "string", required: !0 } }, required: !0 }, Ls = { id: "QueryGetStrategyAggregation", type: "object", properties: { aggregation: { type: "string", required: !0, minLength: 1 } }, required: !0 }, Os = ({ params: t, query: e }) => {
  const s = D(Us, t);
  if (!s) return s;
  const o = ot(Ls, e);
  return !!o || o;
}, gp = (t, e) => O({ ...e, method: L.GET, getEndpoint: Ns, preflightValidation: Os }, t);
var Cs = ((t) => (t.CALCULATE = "calculate", t.RESET = "reset", t.SAVE = "save", t))(Cs || {}), vt = ((t) => (t.NOT_READY = "not_ready", t.READY = "ready", t.PENDING = "pending", t.IN_PROGRESS = "in_progress", t.READ_ONLY = "read_only", t))(vt || {}), _t = ((t) => (t.NAME_ASC = "+name", t.NAME_DES = "-name", t.CREATED_ASC = "+created_on", t.CREATED_DES = "-created_on", t.UPDATED_ASC = "+updated_on", t.UPDATED_DES = "-updated_on", t.ARCHIVED_ASC = "+archived_on", t.ARCHIVED_DES = "-archived_on", t))(_t || {}), gs = ((t) => (t.CATEGORY = "category", t.SUB_CATEGORY = "sub_category", t.BRAND = "brand", t.SUB_BRAND = "sub_brand", t.PACK_GROUP = "pack_group", t))(gs || {});
const bs = ({ params: t, query: e }) => {
  const s = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://platform.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" };
  return typeof t == "boolean" ? `${s.STRATEGY_API}` : t || e ? e ? `${s.STRATEGY_API}` : t ? `${s.STRATEGY_API}/${t.strategy_id}` : void 0 : void 0;
}, Ds = { id: "ParamsGetStrategies", type: "object", properties: { strategy_id: { type: "string", required: !1 } }, required: !1 }, Hs = { id: "QueryGetStrategies", type: "object", properties: { project_id: { type: "integer", required: !1 }, dataset_id: { type: "string", required: !1 }, model_id: { type: "string", required: !1 }, assortment_id: { type: "string", required: !1 }, kpi_id: { type: "string", required: !1 }, planogram_id: { type: "string", required: !1 }, state_status: { type: "string", required: !1, enum: [vt.NOT_READY, vt.READY, vt.PENDING, vt.IN_PROGRESS, vt.READ_ONLY] }, order_by: { type: "string", required: !1, enum: [_t.NAME_ASC, _t.NAME_DES, _t.CREATED_ASC, _t.CREATED_DES, _t.UPDATED_ASC, _t.UPDATED_DES, _t.ARCHIVED_ASC, _t.ARCHIVED_DES] }, limit: { type: "number", required: !1, minimum: 1, maximum: 100 }, offset: { type: "number", required: !1, minimum: 1 } }, required: !1 }, Vs = ({ params: t, query: e }) => {
  let s = !0;
  if (typeof t == "boolean") return !0;
  if (s = D(Ds, t), !s) return s;
  const o = ot(Hs, e);
  return !!o || o;
}, bp = (t, e) => {
  let s;
  return typeof t == "boolean" ? s = { params: t } : s = t, O({ ...e, method: L.GET, getEndpoint: bs, preflightValidation: Vs }, s);
}, Gs = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/strategies/${t.strategy_id}/generate-data`;
}, Ms = { id: "ParamsPostStrategyGenerateData", type: "object", properties: { strategy_id: { type: "string", required: !0 } }, required: !0 }, Fs = { id: "BodyPostStrategyGenerateData", type: "object", properties: { stores: { type: "integer", required: !0 }, categories: { type: "integer", required: !0 }, sub_categories: { type: "integer", required: !0 }, brands: { type: "integer", required: !0 }, sub_brands: { type: "integer", required: !0 }, pack_groups: { type: "integer", required: !0 }, products: { type: "integer", required: !0 }, dist_min: { type: "integer", required: !0 }, dist_max: { type: "integer", required: !0 } }, required: !0 }, ws = ({ params: t, body: e }) => {
  const s = D(Ms, t);
  if (!s) return s;
  const o = Q(Fs, e);
  return !!o || o;
}, Dp = (t) => O({ ...t, method: L.POST, getEndpoint: Gs, preflightValidation: ws }), Ys = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/strategies/${t.strategy_id}/ingest-data`;
}, qs = { id: "ParamsPostStrategyIngestData", type: "object", properties: { strategy_id: { type: "string", required: !0 } }, required: !0 }, lt = { type: "array", required: !0, minItems: 1, items: { type: "string" }, additionalItems: !1 }, js = { id: "BodyPostStrategyIngestData", type: "object", properties: { descriptors: { type: "object", properties: { brands: lt, subBrands: lt, categories: lt, subCategories: lt, subSubCategories: lt, manufacturers: lt, packGroups: lt, productGroups: lt } }, products: { type: "array", required: !0, minItems: 1, items: { type: "object", properties: { id: { type: "integer", required: !0 }, upc: { type: "string", required: !0 }, name: { type: "string", required: !0 }, brand: { type: "string", required: !0 }, subBrand: { type: "string", required: !0 }, category: { type: "string", required: !0 }, subCategory: { type: "string", required: !0 }, subSubCategory: { type: "string", required: !0 }, packGroup: { type: "string", required: !0 }, productGroup: { type: "string", required: !0 }, storeIds: { type: "array", required: !0, items: { type: "integer" }, additionalItems: !1 }, podCount: { type: "integer", required: !0 }, weeklyMovement: { type: "number", required: !0 }, weeklyRevenue: { type: "number", required: !0 } } }, additionalItems: !1 } }, required: !0 }, Ks = ({ params: t, body: e }) => {
  const s = D(qs, t);
  if (!s) return s;
  const o = Q(js, e);
  return !!o || o;
}, Hp = (t) => O({ ...t, method: L.POST, getEndpoint: Ys, preflightValidation: Ks }), $s = () => "https://platform.hivery.ai/api/v1/strategies/", Zs = { id: "BodyPostStrategies", type: "object", properties: { project_id: { type: "integer", required: !0 }, scenario_id: { type: "integer", required: !0 }, name: { type: "string", required: !0, minLength: 1 } }, required: !0 }, xs = ({ body: t }) => Q(Zs, t), Vp = (t) => O({ ...t, method: L.POST, getEndpoint: $s, preflightValidation: xs }), zs = () => "https://platform.hivery.ai/api/v1/curate/users/customer-groups", Gp = (t = !0, e) => O({ ...e, method: L.GET, getEndpoint: zs }, { params: t }), ks = () => "https://platform.hivery.ai/api/v1/curate/users/me", Mp = (t = !0, e) => O({ ...e, method: L.GET, getEndpoint: ks, tenantRequired: !1 }, { params: t }), Bs = () => "https://platform.hivery.ai/api/v1/curate/users/customer-groups", Ws = { id: "BodyPatchUserCustomerGroup", type: "object", properties: { id: { type: "integer", required: !0 } } }, Js = ({ body: t }) => Q(Ws, t), Fp = (t) => O({ ...t, method: L.PATCH, getEndpoint: Bs, preflightValidation: Js }), Qs = () => "https://platform.hivery.ai/api/v1/curate/passwordless/send-email", Xs = { id: "BodyPostLoginPasswordless", type: "object", properties: { email: { type: "string", required: !0, minLength: 1 } } }, to = ({ body: t }) => Q(Xs, t), wp = (t) => O({ ...t, method: L.POST, getEndpoint: Qs, preflightValidation: to, authRequired: !1 }), eo = ({ base_params: t, sendForm: e, maxChunks: s = 10, chunkSize: o = 2097152 }) => {
  const [l, T] = G(!1), [m, v] = G(), C = (N, n, E) => {
    const f = new FormData();
    return N.forEach((A, a) => {
      f.append(`${E + a}-${n}`, A);
    }), f;
  };
  return [l, V((N, n) => {
    const E = N.type, f = N.name, A = N.stream().getReader({ mode: "byob" });
    return v(Math.ceil(N.size / o / s)), new Promise((a, d) => {
      let u = new Uint8Array(o), S = new Uint8Array(o), y = 0, b = 0, i = [], r = 0, _ = {};
      t || n ? (t && (_ = { ...t }), n && (_ = { ...n }), T(!0), A.read(u).then(async function h({ done: p, value: P }) {
        if (p) {
          const c = new Uint8Array(y);
          c.set(S.slice(0, y));
          const I = new Blob([c], { type: E });
          i.push(I), b++;
          const U = C(i, f, r * s), g = { params: { ..._, part_number: r }, body: U };
          return r++, console.debug(`readStream() complete. Total Form Count: ${r}`), await e(g), a({ readComplete: !0, partCount: b, formCount: r }), void T(!1);
        }
        if (u = new Uint8Array(o), y + P.byteLength > o) {
          const c = o - y, I = new Uint8Array(o);
          I.set(S), I.set(P.slice(0, c), c);
          const U = new Blob([I], { type: E });
          i.push(U), b++, S = new Uint8Array(o), S.set(P.slice(c + 1, P.byteLength)), y = P.byteLength - (c + 1);
        } else if (S.set(P, y), y += P.byteLength, y === o) {
          const c = new Blob([S], { type: E });
          i.push(c), b++, S = new Uint8Array(o), y = 0;
        }
        if (b === s) {
          const c = C(i, f, r * s), I = { params: { ..._, part_number: r }, body: c };
          r++, await e(I), b = 0, i = [];
        }
        return A.read(u).then(h);
      })) : d({ readComplete: !1, partCount: b, formCount: r, isError: !0, error: "Unable to build file forms: missing request params" });
    });
  }, [o, s, t, e]), m];
}, jt = 1048576, Ee = 1024 * jt, Ie = de(null), Yp = () => {
  const t = ue(Ie);
  if (!t) throw new Error("useFileUploadContextSSDI must be used within a FileUploadSSDIProvider");
  return t;
}, ro = fe(({ children: t, kind: e, ...s }, o) => {
  const [l, T] = G(null), [m, v] = G(null), [C, N] = G(!1), [n, E] = G(!1), [f, A] = G(!1), [a, d] = G(!1), [u, S] = G(!1), [y, b] = G([]), [i, r] = G(), [_, h] = G(0), p = rt(0), [P, c] = G(), I = at(() => {
    if (!l) return;
    const H = l.size;
    return H < jt ? `${(H / 1024).toFixed(2)}KB` : H < Ee ? `${(H / jt).toFixed(2)}MB` : `${(H / Ee).toFixed(2)}GB`;
  }, [l]), [U, g, $, Y] = Jr(), [x, ut, q, W] = ra(), it = V(() => {
    h((H) => H + 1);
  }, []), ht = V(() => {
    if (!(x || u || W)) if (i) if (g) if (m) {
      if (_ === i.formCount) {
        const H = (performance.now() - p.current) / 1e3, M = ye(y, "part").map((k) => k.id);
        c(H), d(!0), A(!1), q({ params: { id: g.id }, body: { filePartIds: M, kind: g.kind, ext: m } });
      }
    } else console.debug("unable to process uploaded file: file ext not known");
    else console.debug("unable to process uploaded file empty queue: file meta data missing");
    else console.debug("unable to process uploaded file empty queue: file stats missing");
  }, [m, _, i, y, W, q, u, x, g]), ft = V((H) => {
    b((M) => H.isError ? M : [...M, { id: H.data.id, part: H.data.partNumber }]);
  }, []), [It, Ot] = oa({ headers: { "X-File-Upload-Kind": e }, onFinish: it, onEmptyQueue: ht, onResponse: ft }), [yt, Ct, Rt] = eo({ sendForm: Ot }), gt = V((H) => {
    S(!1), d(!1), A(!1), E(!1), N(!1), r(void 0), h(0), c(void 0), p.current = 0;
    const M = ve(H.type);
    M && (v(M), T(H));
  }, []), bt = V(() => {
    !C && l && (S(!1), d(!1), A(!1), E(!1), r(void 0), h(0), c(void 0), p.current = 0, N(!0), $({ body: { kind: e, name: l.name } }));
  }, [l, C, e, $]), R = at(() => ({ isFileInProgress: C, isFilePrepared: n, isFilePreparing: U, isFileUploaded: a, isFileUploading: f, isFileFinialized: u, isFileFinializing: x, fileRequestCount: _, fileRequestExpectedCount: Rt, fileStats: i, fileSizeLabel: I, fileUploadDuration: P, setFile: gt, sendFile: bt, fileUploadError: Y || W }), [_, Rt, I, i, P, W, u, x, C, n, U, a, f, Y, bt, gt]);
  return X(() => {
    Y && N(!1);
  }, [Y]), X(() => {
    !l || !g || yt || It || f || a || (p.current = performance.now(), Ct(l, { id: g.id }).then((H) => {
      r(H);
    }), c(void 0), A(!0), E(!0));
  }, [Ct, l, yt, x, a, f, It, g]), X(() => {
    W && N(!1);
  }, [W]), X(() => {
    ut && (S(!0), N(!1));
  }, [ut]), wt.jsx(Ie.Provider, { value: R, children: wt.jsx("div", { ref: o, ...s, children: t }) });
});
ro.displayName = "FileUploadSSDIProvider";
export {
  rr as AGENT_ASSISTANT_TYPES,
  fo as AGENT_MESSAGE_CONTENT_CHART_DATA_FIELD_KINDS,
  To as AGENT_MESSAGE_CONTENT_CHART_GEOMETRY_KINDS,
  So as AGENT_MESSAGE_CONTENT_CHART_IMAGE_MIME_KINDS,
  mo as AGENT_MESSAGE_CONTENT_KINDS,
  ir as AGENT_MESSAGE_ROLES,
  Io as AGENT_MESSAGE_STATUSES,
  Po as AGENT_RUN_STATUSES,
  ar as AGENT_THREAD_SCOPE_LEVELS,
  ne as ALGORITHM_TYPES,
  br as AssortedStatus,
  ep as CONSTRAINT_KINDS_ASSORTMENT_CONTROLS,
  rp as CONSTRAINT_KINDS_ASSORTMENT_OVERRIDES,
  ip as CONSTRAINT_KINDS_SPACE_APPEARANCE,
  ap as CONSTRAINT_KINDS_SPACE_LIMIT,
  sp as CONSTRAINT_KINDS_SPACE_MERCHANDIZING,
  wr as DocumentState,
  Ne as DomExceptionName,
  dt as EditRequestsCommandTypes,
  qt as EditRequestsStatuses,
  Bo as FILE_EXPORT_STATUS,
  Oa as FILE_EXPORT_TYPE,
  L as FetchMethod,
  Ie as FileUploadContextSSDI,
  ro as FileUploadSSDIProvider,
  Rs as FixtureType,
  pe as GET_PROJECT_ORDER_BY,
  ys as MerchandiseStyle,
  Ut as PlanogramFileFormat,
  La as ProjectImportStatuses,
  hi as SCENARIO_NATIONAL_RESULTS_GROUPINGS,
  Vt as SCENARIO_NATIONAL_RESULTS_ORDER,
  _i as ScenarioOptimizationCodes,
  Ei as ScenarioOptimizationStatuses,
  ui as ScenarioReviewMetaStatuses,
  di as ScenarioType,
  Ya as SchemaBodyPatchProject,
  $a as SchemaBodyPatchProjectSettings,
  Ui as SchemaBodyPatchReview,
  Hi as SchemaBodyPatchScenarioAssignGroup,
  $i as SchemaBodyPatchScenarioGroupRename,
  Ws as SchemaBodyPatchUserCustomerGroup,
  or as SchemaBodyPostAgentAssistant,
  _r as SchemaBodyPostAgentMessage,
  cr as SchemaBodyPostAgentRun,
  Ir as SchemaBodyPostAgentThread,
  Br as SchemaBodyPostFilesUpload,
  ta as SchemaBodyPostFilesUploadComplete,
  Xs as SchemaBodyPostLoginPasswordless,
  za as SchemaBodyPostProject,
  ki as SchemaBodyPostReview,
  Qi as SchemaBodyPostScenarioGroups,
  Zs as SchemaBodyPostStrategies,
  Fs as SchemaBodyPostStrategyGenerateData,
  js as SchemaBodyPostStrategyIngestData,
  va as SchemaParamsDeleteProjects,
  Xa as SchemaParamsDeleteScenario,
  qe as SchemaParamsGetAgentAssistants,
  $e as SchemaParamsGetAgentMessage,
  ze as SchemaParamsGetAgentRun,
  We as SchemaParamsGetAgentThreads,
  Tr as SchemaParamsGetAssortment,
  es as SchemaParamsGetClusterPlanograms,
  Ea as SchemaParamsGetCurateProduct,
  ua as SchemaParamsGetCurateProductSummaries,
  is as SchemaParamsGetCurateStoreProducts,
  ns as SchemaParamsGetCurateStores,
  Hr as SchemaParamsGetDocuments,
  Mr as SchemaParamsGetDocumentsSummaries,
  qr as SchemaParamsGetEditRequestsMostRecent,
  vr as SchemaParamsGetPODS,
  Aa as SchemaParamsGetProductSummaries,
  Ta as SchemaParamsGetProducts,
  Na as SchemaParamsGetProjectDataDetails,
  ga as SchemaParamsGetProjectExportUrl,
  Va as SchemaParamsGetProjects,
  ri as SchemaParamsGetReviews,
  pi as SchemaParamsGetScenarioGroups,
  Ti as SchemaParamsGetScenarios,
  vi as SchemaParamsGetScenariosBaseCore,
  li as SchemaParamsGetScenariosNationalResults,
  us as SchemaParamsGetStoreKpiSummaries,
  ls as SchemaParamsGetStoresPlanograms,
  ms as SchemaParamsGetStoresSummaries,
  Ds as SchemaParamsGetStrategies,
  Us as SchemaParamsGetStrategyAggregation,
  Nr as SchemaParamsGetTasksStatus,
  Xe as SchemaParamsListAgentMessages,
  wa as SchemaParamsPatchProject,
  Ka as SchemaParamsPatchProjectSettings,
  Ni as SchemaParamsPatchReview,
  Ci as SchemaParamsPatchScenario,
  Di as SchemaParamsPatchScenarioAssignGroup,
  Mi as SchemaParamsPatchScenarioGroupArchive,
  Yi as SchemaParamsPatchScenarioGroupArchiveUndo,
  Ki as SchemaParamsPatchScenarioGroupRename,
  Er as SchemaParamsPostAgentMessage,
  hr as SchemaParamsPostAgentRun,
  Zr as SchemaParamsPostEditRequestsCreate,
  Cr as SchemaParamsPostExportAssortment,
  Ps as SchemaParamsPostExportPlanograms,
  Xr as SchemaParamsPostFilesUploadComplete,
  ia as SchemaParamsPostFilesUploadPart,
  zi as SchemaParamsPostReview,
  Ji as SchemaParamsPostScenarioGroups,
  Ms as SchemaParamsPostStrategyGenerateData,
  qs as SchemaParamsPostStrategyIngestData,
  Wa as SchemaQueryGetConstraintTypess,
  ha as SchemaQueryGetCurateProductSummaries,
  ss as SchemaQueryGetCurateStoreProducts,
  Es as SchemaQueryGetCurateStores,
  Ia as SchemaQueryGetProductSummaries,
  Ga as SchemaQueryGetProjects,
  Ai as SchemaQueryGetScenariosNationalResults,
  fs as SchemaQueryGetStoreSummaries,
  Hs as SchemaQueryGetStrategies,
  Ls as SchemaQueryGetStrategyAggregation,
  tr as SchemaQueryListAgentMessages,
  _t as StrategiesOrderBy,
  gs as StrategyAggregationType,
  vt as StrategyStatusType,
  Cs as StrategyTaskType,
  Pt as TaskStatuses,
  Ae as UPLOAD_FILE_KINDS,
  qo as UPLOAD_FILE_STATUSES,
  ce as UserStateContext,
  He as UserStateContextInit,
  he as UserStateInit,
  no as UserStateProvider,
  Mt as cleanQueryParams,
  Pa as endpointDeleteProjects,
  Qa as endpointDeleteScenario,
  Ye as endpointGetAgentAssistants,
  Ke as endpointGetAgentMessage,
  xe as endpointGetAgentRun,
  Be as endpointGetAgentThreads,
  fr as endpointGetAssortment,
  ts as endpointGetClusterPlanograms,
  Ba as endpointGetConstraintTypess,
  na as endpointGetCurateProduct,
  da as endpointGetCurateProductSummaries,
  as as endpointGetCurateStoreProducts,
  ps as endpointGetCurateStores,
  zs as endpointGetCustomerGroups,
  Dr as endpointGetDocuments,
  Gr as endpointGetDocumentsSummaries,
  Yr as endpointGetEditRequestsMostRecent,
  ks as endpointGetMe,
  Pr as endpointGetPODs,
  pa as endpointGetPreferences,
  la as endpointGetProductSummaries,
  fa as endpointGetProducts,
  Ra as endpointGetProjectDataDetails,
  Ca as endpointGetProjectExportUrl,
  Ha as endpointGetProjects,
  Da as endpointGetProjectsFileUploadConfig,
  ei as endpointGetReviews,
  ii as endpointGetScenarioAggregationOptions,
  si as endpointGetScenarioFileUploadConfig,
  oi as endpointGetScenarioGroups,
  fi as endpointGetScenarios,
  Pi as endpointGetScenariosBaseCore,
  ci as endpointGetScenariosNationalResults,
  ds as endpointGetStoreKpiSummaries,
  cs as endpointGetStoresPlanograms,
  bs as endpointGetStrategies,
  Ns as endpointGetStrategyAggregation,
  Rr as endpointGetTasksStatus,
  zr as endpointGetTestAuth,
  Qe as endpointListAgentMessages,
  Fa as endpointPatchProject,
  ja as endpointPatchProjectSettings,
  Ri as endpointPatchReview,
  Oi as endpointPatchScenario,
  bi as endpointPatchScenarioAssignGroup,
  Gi as endpointPatchScenarioGroupArchive,
  wi as endpointPatchScenarioGroupArchiveUndo,
  ji as endpointPatchScenarioGroupRename,
  Bs as endpointPatchUserCustomerGroup,
  sr as endpointPostAgentAssistant,
  nr as endpointPostAgentMessage,
  ur as endpointPostAgentRun,
  Ar as endpointPostAgentThread,
  $r as endpointPostEditRequestsCreate,
  Or as endpointPostExportAssortment,
  Ss as endpointPostExportPlanograms,
  kr as endpointPostFilesUpload,
  Qr as endpointPostFilesUploadComplete,
  aa as endpointPostFilesUploadPart,
  Qs as endpointPostLoginPasswordless,
  xa as endpointPostProject,
  xi as endpointPostReview,
  Wi as endpointPostScenarioGroups,
  $s as endpointPostStrategies,
  Gs as endpointPostStrategyGenerateData,
  Ys as endpointPostStrategyIngestData,
  mi as formatQueryGetScenariosNationalResults,
  Me as getChunkSize,
  Is as getEndpointGetStoresSummaries,
  oo as getEnvConfig,
  ve as getFileExt,
  Ue as handleDomException,
  we as handleHTTPStatus,
  po as indexByProp,
  ya as preflightValidationDeleteProjects,
  ti as preflightValidationDeleteScenario,
  je as preflightValidationGetAgentAssistants,
  Ze as preflightValidationGetAgentMessage,
  ke as preflightValidationGetAgentRun,
  Je as preflightValidationGetAgentThreads,
  Sr as preflightValidationGetAssortment,
  rs as preflightValidationGetClusterPlanograms,
  Ja as preflightValidationGetConstraintTypess,
  _a as preflightValidationGetCurateProduct,
  ca as preflightValidationGetCurateProductSummaries,
  os as preflightValidationGetCurateStoreProducts,
  _s as preflightValidationGetCurateStores,
  Vr as preflightValidationGetDocuments,
  Fr as preflightValidationGetDocumentsSummaries,
  jr as preflightValidationGetEditRequestsMostRecent,
  yr as preflightValidationGetPODs,
  ma as preflightValidationGetProductSummaries,
  Sa as preflightValidationGetProducts,
  Ua as preflightValidationGetProjectDataDetails,
  ba as preflightValidationGetProjectExportUrl,
  Ma as preflightValidationGetProjects,
  ai as preflightValidationGetReviews,
  ni as preflightValidationGetScenarioGroups,
  Si as preflightValidationGetScenarios,
  yi as preflightValidationGetScenariosBaseCore,
  Ii as preflightValidationGetScenariosNationalResults,
  hs as preflightValidationGetStoreKpiSummaries,
  Ts as preflightValidationGetStoreSummaries,
  As as preflightValidationGetStoresPlanograms,
  Vs as preflightValidationGetStrategies,
  Os as preflightValidationGetStrategyAggregation,
  Ur as preflightValidationGetTasksStatus,
  er as preflightValidationListAgentMessages,
  qa as preflightValidationPatchProject,
  Za as preflightValidationPatchProjectSettings,
  Li as preflightValidationPatchReview,
  gi as preflightValidationPatchScenario,
  Vi as preflightValidationPatchScenarioAssignGroup,
  Fi as preflightValidationPatchScenarioGroupArchive,
  qi as preflightValidationPatchScenarioGroupArchiveUndo,
  Zi as preflightValidationPatchScenarioGroupRename,
  Js as preflightValidationPatchUserCustomerGroup,
  pr as preflightValidationPostAgentAssistant,
  dr as preflightValidationPostAgentMessage,
  lr as preflightValidationPostAgentRun,
  mr as preflightValidationPostAgentThread,
  xr as preflightValidationPostEditRequestsCreate,
  gr as preflightValidationPostExportAssortment,
  vs as preflightValidationPostExportPlanograms,
  Wr as preflightValidationPostFilesUpload,
  ea as preflightValidationPostFilesUploadComplete,
  sa as preflightValidationPostFilesUploadPart,
  to as preflightValidationPostLoginPasswordless,
  ka as preflightValidationPostProject,
  Bi as preflightValidationPostReview,
  Xi as preflightValidationPostScenarioGroups,
  xs as preflightValidationPostStrategies,
  ws as preflightValidationPostStrategyGenerateData,
  Ks as preflightValidationPostStrategyIngestData,
  oe as setUser,
  re as setUserFeatures,
  ae as setUserTenant,
  ie as setUserTenantSlug,
  se as setUserToken,
  ye as sortByProp,
  zo as useDeleteProject,
  np as useDeleteScenario,
  Lt as useFetch,
  Eo as useFetchBatch,
  Ge as useFetchConcurrentAsyc,
  _o as useFetchDrain,
  O as useFetchRequest,
  eo as useFileChunkFormBuilder,
  Yp as useFileUploadContextSSDI,
  uo as useGetAgentAssistants,
  ho as useGetAgentMessage,
  co as useGetAgentRun,
  lo as useGetAgentThreads,
  Uo as useGetAssortments,
  Fe as useGetChunk,
  yp as useGetClusterPlanograms,
  pp as useGetConstraintTypes,
  Ko as useGetCurateProduct,
  $o as useGetCurateProductSummaries,
  Rp as useGetCurateStoreProducts,
  Np as useGetCurateStores,
  Gp as useGetCustomerGroups,
  Co as useGetDocuments,
  go as useGetDocumentsSummaries,
  Kr as useGetEditRequestsMostRecent,
  Mp as useGetMe,
  Lo as useGetPODs,
  jo as useGetPreferences,
  Zo as useGetProductSummaries,
  xo as useGetProducts,
  ko as useGetProjectDataDetails,
  Wo as useGetProjectExportUrl,
  Qo as useGetProjects,
  Jo as useGetProjectsFileUploadConfig,
  Ep as useGetReviews,
  _p as useGetScenarioAggregationOptions,
  dp as useGetScenarioFileUploadConfig,
  up as useGetScenarioGroups,
  cp as useGetScenarios,
  lp as useGetScenariosBaseCore,
  hp as useGetScenariosNationalResults,
  Up as useGetStoreKpiSummaries,
  Lp as useGetStoresPlanograms,
  Op as useGetStoresSummaries,
  bp as useGetStrategies,
  gp as useGetStrategyAggregation,
  Lr as useGetTasksStatus,
  Yo as useGetTestAuth,
  Ao as useListAgentMessages,
  Xo as usePatchProject,
  tp as usePatchProjectSettings,
  Ap as usePatchReview,
  Ip as usePatchScenario,
  mp as usePatchScenarioAssignGroup,
  fp as usePatchScenarioGroupArchive,
  Tp as usePatchScenarioGroupArchiveUndo,
  Sp as usePatchScenarioGroupRename,
  Fp as usePatchUserCustomerGroup,
  le as usePollTaskStatus,
  vo as usePostAgentAssistant,
  yo as usePostAgentMessage,
  Ro as usePostAgentRun,
  No as usePostAgentThread,
  bo as usePostEditRequestDropPosition,
  Do as usePostEditRequestDropProduct,
  Ho as usePostEditRequestInsertPosition,
  Vo as usePostEditRequestInsertProduct,
  Go as usePostEditRequestMovePosition,
  Mo as usePostEditRequestSetFacings,
  Fo as usePostEditRequestSwapPosition,
  wo as usePostEditRequestSwapProduct,
  At as usePostEditRequestsCreate,
  Oo as usePostExportAssortment,
  Cp as usePostExportPlanograms,
  Jr as usePostFilesUpload,
  ra as usePostFilesUploadComplete,
  oa as usePostFilesUploadPart,
  wp as usePostLoginPasswordless,
  op as usePostProject,
  Pp as usePostReview,
  vp as usePostScenarioGroups,
  Vp as usePostStrategies,
  Dp as usePostStrategyGenerateData,
  Hp as usePostStrategyIngestData,
  be as useSetUser,
  Le as useSetUserFeatures,
  Oe as useSetUserTenant,
  Ce as useSetUserTenantSlug,
  ge as useSetUserToken,
  Ve as useUserState,
  De as userReducer,
  Q as validateBody,
  D as validateParams,
  ot as validateQuery,
  Gt as valueByProp
};
//# sourceMappingURL=api.js.map
